import React, { useState, useEffect } from 'react';
import informacionGeneralService from '../services/informacionGeneralService';
import atributoService from '../services/atributoService';
import configuracionTareoService from '../services/configuracionTareoService';
import configuracionRentaQuintaService from '../services/configuracionRentaQuintaService';
import configuracionTasaNocturnaService from '../services/configuracionTasaNocturnaService';
import configuracionContratosService from '../services/configuracionContratosService';
import configuracionAniversarioLaboralService from '../services/configuracionAniversarioLaboralService';
import configuracionPlanillaAlternativaService from '../services/configuracionPlanillaAlternativaService';
import configuracionBoletaService from '../services/configuracionBoletaService';
import configuracionViaticosStandardService from '../services/configuracionViaticosStandardService';
import configuracionExpedienteLaboralService from '../services/configuracionExpedienteLaboralService';
import plameConfiguracionService from '../services/plameConfiguracionService';
import funcionesCargoContratoService from '../services/funcionesCargoContratoService';
import conceptosAfectosTareosService from '../services/conceptosAfectosTareosService';
import conceptosNoAfectanVacacionesService from '../services/conceptosNoAfectanVacacionesService';
import conceptosAfectanLicenciaGoceHaberService from '../services/conceptosAfectanLicenciaGoceHaberService';
import conceptosEstaticosService from '../services/conceptosEstaticosService';
import asignacionUsuarioProyectoService from '../services/asignacionUsuarioProyectoService';
import fechasComputoRhService from '../services/fechasComputoRhService';
import feriadosPagoDobleService from '../services/feriadosPagoDobleService';
import empresaService from '../services/empresaService';
import empleadoService from '../services/empleadoService';
import { ENV_CONFIG } from '../config/environment';
import ConceptosAfectosTareosModal from '../components/ConceptosAfectosTareosModal';
import ConceptosNoAfectanVacacionesModal from '../components/ConceptosNoAfectanVacacionesModal';
import ConceptosAfectanLicenciaGoceHaberModal from '../components/ConceptosAfectanLicenciaGoceHaberModal';
import ConceptosEstaticosModal from '../components/ConceptosEstaticosModal';
import AsignacionUsuarioProyectoModal from '../components/AsignacionUsuarioProyectoModal';
import Toast from '../components/Toast';
import { useAuth } from '../hooks/useAuth';

function formatearFechaAniversario(fechaIso) {
  if (!fechaIso) return '—';
  const [y, m, d] = String(fechaIso).split('-');
  if (!y || !m || !d) return fechaIso;
  return `${d}/${m}/${y}`;
}
function resolverUrlArchivoPublico(url) {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  const base = ENV_CONFIG.API_BASE_URL.replace(/\/api\/?$/, '');
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}

const Configuracion = () => {
  // Hook de autenticación
  const { selectedCompany, selectCompany } = useAuth();
  
  // Estados para UIT y RMV
  const [uitData, setUitData] = useState([]);
  const [sueldoMinimoData, setSueldoMinimoData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Estados para atributos (ahora vienen de la API)
  const [tiposAtributos, setTiposAtributos] = useState([]);
  const [atributosData, setAtributosData] = useState({});
  
  // Estados para configuración de tareo
  const [tipoTareo, setTipoTareo] = useState(2); // 1 = Simple, 2 = Detallado, 3 = Por Horas
  const [tiposTareoDisponibles, setTiposTareoDisponibles] = useState([]);
  const [tiposTareoCompletos, setTiposTareoCompletos] = useState([]); // Incluye la nueva opción
  const [descontarDescansos, setDescontarDescansos] = useState(true); // Por defecto activado
  const [modoHorasSimple, setModoHorasSimple] = useState('reales'); // reales | fijas_8 (solo tareo simple)
  
  // Estados para configuración de renta de quinta
  const [rentaQuintaActivada, setRentaQuintaActivada] = useState(false); // Por defecto desactivada

  // Estados para tasa nocturna
  const [tasaNocturnaActivada, setTasaNocturnaActivada] = useState(false);
  const [calcularTasaNocturnaEnPlanilla, setCalcularTasaNocturnaEnPlanilla] = useState(true);
  const [horasTasaNocturna, setHorasTasaNocturna] = useState('8');
  const [guardandoTasaNocturna, setGuardandoTasaNocturna] = useState(false);

  // Estados para activar contratos
  const [contratosActivados, setContratosActivados] = useState(false);
  const [planillaAlternativaActivada, setPlanillaAlternativaActivada] = useState(false);
  const [estiloBoleta, setEstiloBoleta] = useState('colorido');
  const [viaticosStandardActivados, setViaticosStandardActivados] = useState(false);
  const [viaticosPlameId, setViaticosPlameId] = useState('');
  const [viaticosNumeroReciboActivo, setViaticosNumeroReciboActivo] = useState(false);
  const [viaticosDestinoDefault, setViaticosDestinoDefault] = useState('interna');
  const [conceptosPlameViaticos, setConceptosPlameViaticos] = useState([]);
  const [guardandoViaticosExtra, setGuardandoViaticosExtra] = useState(false);
  const [expedienteLaboralActivado, setExpedienteLaboralActivado] = useState(false);
  const [funcionesCargoContrato, setFuncionesCargoContrato] = useState([]);
  const [loadingFuncionesCargo, setLoadingFuncionesCargo] = useState(false);
  const [cargoFuncionesSeleccionado, setCargoFuncionesSeleccionado] = useState('');
  const [textoFuncionesCargo, setTextoFuncionesCargo] = useState('');
  const [guardandoFuncionesCargo, setGuardandoFuncionesCargo] = useState(false);
  const [editandoFuncionesCargoId, setEditandoFuncionesCargoId] = useState(null);
  
  // Estados para conceptos afectos a tareos
  const [showConceptosModal, setShowConceptosModal] = useState(false);
  const [conceptosAfectos, setConceptosAfectos] = useState([]);
  const [loadingConceptosAfectos, setLoadingConceptosAfectos] = useState(false);

  const [showConceptosNoVacacionesModal, setShowConceptosNoVacacionesModal] = useState(false);
  const [conceptosNoAfectanVacaciones, setConceptosNoAfectanVacaciones] = useState([]);
  const [loadingConceptosNoVacaciones, setLoadingConceptosNoVacaciones] = useState(false);

  const [showConceptosLicenciaGoceModal, setShowConceptosLicenciaGoceModal] = useState(false);
  const [conceptosAfectanLicenciaGoceHaber, setConceptosAfectanLicenciaGoceHaber] = useState([]);
  const [loadingConceptosLicenciaGoce, setLoadingConceptosLicenciaGoce] = useState(false);
  
  // Estados para conceptos estáticos
  const [showConceptosEstaticosModal, setShowConceptosEstaticosModal] = useState(false);
  const [conceptosEstaticos, setConceptosEstaticos] = useState([]);
  const [loadingConceptosEstaticos, setLoadingConceptosEstaticos] = useState(false);
  
  // Estados para asignaciones usuario-proyecto
  const [showAsignacionesModal, setShowAsignacionesModal] = useState(false);
  const [asignacionesUsuarioProyecto, setAsignacionesUsuarioProyecto] = useState([]);
  const [loadingAsignaciones, setLoadingAsignaciones] = useState(false);

  // Estados para fechas de cómputo de Recibo por Honorarios
  const [fechasComputoRh, setFechasComputoRh] = useState([]);
  const [loadingFechasComputoRh, setLoadingFechasComputoRh] = useState(false);
  const [tituloFechaComputoRh, setTituloFechaComputoRh] = useState('');
  const [diaComputoRh, setDiaComputoRh] = useState('');
  const [guardandoFechaComputoRh, setGuardandoFechaComputoRh] = useState(false);

  // Feriados laborados con pago doble (fecha específica)
  const [feriadosPagoDoble, setFeriadosPagoDoble] = useState([]);
  const [loadingFeriadosPagoDoble, setLoadingFeriadosPagoDoble] = useState(false);
  const [fechaFeriadoPagoDoble, setFechaFeriadoPagoDoble] = useState('');
  const [descripcionFeriadoPagoDoble, setDescripcionFeriadoPagoDoble] = useState('');
  const [guardandoFeriadoPagoDoble, setGuardandoFeriadoPagoDoble] = useState(false);

  // Aniversarios laborales (años de servicio)
  const [aniversariosActivados, setAniversariosActivados] = useState(false);
  const [aniosAniversario, setAniosAniversario] = useState('5');
  const [diasAnticipacionAniversario, setDiasAnticipacionAniversario] = useState('60');
  const [loadingAniversarios, setLoadingAniversarios] = useState(false);
  const [guardandoAniversarios, setGuardandoAniversarios] = useState(false);
  const [resultadoAniversarios, setResultadoAniversarios] = useState(null);
  
  // Estados para mensajes toast
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('info');

  // Estados para subida de firmas
  const [selectedFirma, setSelectedFirma] = useState(null);
  const [previewFirma, setPreviewFirma] = useState(null);
  const [uploadingFirma, setUploadingFirma] = useState(false);
  const [firmaActual, setFirmaActual] = useState(null);
  const [loadingFirma, setLoadingFirma] = useState(false);

  const [selectedLogo, setSelectedLogo] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoActual, setLogoActual] = useState(null);
  const [loadingLogo, setLoadingLogo] = useState(false);

  const [representanteLegal, setRepresentanteLegal] = useState('');
  const [direccionEmpresa, setDireccionEmpresa] = useState('');
  const [dniRepresentante, setDniRepresentante] = useState('');
  const [guardandoRepresentanteLegal, setGuardandoRepresentanteLegal] = useState(false);

  useEffect(() => {
    cargarDatos();
  }, [selectedCompany]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      console.log('🔄 Cargando datos de configuración...');
      console.log('🏢 Empresa seleccionada:', selectedCompany);

      // Verificar que hay empresa seleccionada
      if (!selectedCompany?.id) {
        console.log('⚠️ No hay empresa seleccionada');
        setLoading(false);
        return;
      }

      // Cargar información general (UIT y RMV)
      const informacionResponse = await informacionGeneralService.obtenerInformacionActual();
      
      console.log('📊 Respuesta información general:', informacionResponse);
      
      if (informacionResponse.success) {
        const sueldoMinimoArray = informacionResponse.data.sueldo_minimo ? [informacionResponse.data.sueldo_minimo] : [];
        const uitArray = informacionResponse.data.uit ? [informacionResponse.data.uit] : [];
        
        setSueldoMinimoData(sueldoMinimoArray);
        setUitData(uitArray);
      }

      // Cargar tipos de atributos y configuración completa
      const [tiposResponse, configuracionResponse, tiposTareoResponse, configuracionTareoResponse] = await Promise.all([
        atributoService.obtenerTiposAtributos(),
        atributoService.obtenerConfiguracionCompleta(selectedCompany.id),
        configuracionTareoService.obtenerTiposTareo(),
        configuracionTareoService.obtenerConfiguracionTareo(selectedCompany.id)
      ]);

      // Cargar conceptos afectos a tareos
      await cargarConceptosAfectos();

      await cargarConceptosNoAfectanVacaciones();

      await cargarConceptosAfectanLicenciaGoceHaber();

      // Cargar conceptos estáticos
      await cargarConceptosEstaticos();

      // Cargar asignaciones usuario-proyecto
      await cargarAsignacionesUsuarioProyecto();

      // Cargar fechas de cómputo de Recibo por Honorarios
      await cargarFechasComputoRh();

      await cargarFeriadosPagoDoble();

      await cargarConfiguracionAniversariosLaborales();

      // Cargar firma actual
      await cargarFirmaActual();

      await cargarLogoActual();

      await cargarRepresentanteLegal();

      console.log('🏷️ Tipos de atributos:', tiposResponse);
      console.log('⚙️ Configuración completa:', configuracionResponse);
      console.log('⏰ Tipos de tareo:', tiposTareoResponse);
      console.log('🔧 Configuración de tareo:', configuracionTareoResponse);

      if (tiposResponse.success) {
        setTiposAtributos(tiposResponse.data);
      }

      if (configuracionResponse.success) {
        setAtributosData(configuracionResponse.data.sub_atributos || {});
      }

      // 🕐 USAR TIPOS DE TAREO DIRECTAMENTE DEL BACKEND
      const tiposDelBackend = tiposTareoResponse.success ? tiposTareoResponse.data : [];
      setTiposTareoDisponibles(tiposDelBackend);
      setTiposTareoCompletos(tiposDelBackend); // Ahora el backend ya incluye la opción "Tareo por Horas"
      
      console.log('⏰ Tipos de tareo del backend:', tiposDelBackend);

      if (configuracionTareoResponse.success) {
        setTipoTareo(configuracionTareoResponse.data.tipo_tareo || 2);
        setDescontarDescansos(configuracionTareoResponse.data.descontar_descansos ?? true);
        setModoHorasSimple(
          String(configuracionTareoResponse.data.modo_horas_simple || 'reales').toLowerCase() === 'fijas_8'
            ? 'fijas_8'
            : 'reales'
        );
      }

      // Cargar configuración de renta de quinta
      try {
        const configuracionRentaResponse = await configuracionRentaQuintaService.obtenerConfiguracion(selectedCompany.id);
        if (configuracionRentaResponse.success) {
          setRentaQuintaActivada(configuracionRentaResponse.data.activo ?? false);
          console.log('💰 Configuración de renta de quinta cargada:', configuracionRentaResponse.data.activo);
        } else {
          console.log('💰 Error al cargar configuración de renta de quinta, usando valor por defecto');
          setRentaQuintaActivada(false);
        }
      } catch (error) {
        console.error('💰 Error al cargar configuración de renta de quinta:', error);
        setRentaQuintaActivada(false);
      }

      try {
        const configuracionTasaNocturnaResponse = await configuracionTasaNocturnaService.obtenerConfiguracion(selectedCompany.id);
        if (configuracionTasaNocturnaResponse.success) {
          setTasaNocturnaActivada(configuracionTasaNocturnaResponse.data.activo ?? false);
          setCalcularTasaNocturnaEnPlanilla(configuracionTasaNocturnaResponse.data.calcular_en_planilla ?? true);
          setHorasTasaNocturna(String(configuracionTasaNocturnaResponse.data.horas_tasa_nocturna ?? 8));
        } else {
          setTasaNocturnaActivada(false);
          setCalcularTasaNocturnaEnPlanilla(true);
          setHorasTasaNocturna('8');
        }
      } catch (error) {
        console.error('🌙 Error al cargar configuración de tasa nocturna:', error);
        setTasaNocturnaActivada(false);
        setCalcularTasaNocturnaEnPlanilla(true);
        setHorasTasaNocturna('8');
      }

      try {
        const configuracionContratosResponse = await configuracionContratosService.obtenerConfiguracion(selectedCompany.id);
        if (configuracionContratosResponse.success) {
          const activo = configuracionContratosResponse.data.activo ?? false;
          setContratosActivados(activo);
          if (activo) {
            await cargarFuncionesCargoContrato();
          } else {
            setFuncionesCargoContrato([]);
          }
        } else {
          setContratosActivados(false);
          setFuncionesCargoContrato([]);
        }
      } catch (error) {
        console.error('📄 Error al cargar configuración de contratos:', error);
        setContratosActivados(false);
        setFuncionesCargoContrato([]);
      }

      try {
        const configPlanillaAlt = await configuracionPlanillaAlternativaService.obtenerConfiguracion(
          selectedCompany.id
        );
        if (configPlanillaAlt.success) {
          setPlanillaAlternativaActivada(configPlanillaAlt.data?.activo ?? false);
        } else {
          setPlanillaAlternativaActivada(false);
        }
      } catch (error) {
        console.error('Error al cargar configuración de planilla alternativa:', error);
        setPlanillaAlternativaActivada(false);
      }

      try {
        const configBoleta = await configuracionBoletaService.obtenerConfiguracion(selectedCompany.id);
        if (configBoleta.success) {
          const estilo = String(configBoleta.data?.estilo_boleta || '').toLowerCase();
          if (estilo === 'estandar' || estilo === 'azul_oro' || estilo === 'colorido') {
            setEstiloBoleta(estilo);
          } else {
            setEstiloBoleta(configBoleta.data?.boleta_estandar ? 'estandar' : 'colorido');
          }
        } else {
          setEstiloBoleta('colorido');
        }
      } catch (error) {
        console.error('Error al cargar configuración de boleta:', error);
        setEstiloBoleta('colorido');
      }

      try {
        const configViaticos = await configuracionViaticosStandardService.obtenerConfiguracion(
          selectedCompany.id
        );
        if (configViaticos.success) {
          setViaticosStandardActivados(configViaticos.data?.activo ?? false);
          setViaticosPlameId(configViaticos.data?.plame_configuracion_id ? String(configViaticos.data.plame_configuracion_id) : '');
          setViaticosNumeroReciboActivo(Boolean(configViaticos.data?.numero_recibo_activo));
          setViaticosDestinoDefault(
            String(configViaticos.data?.tipo_boleta_destino || 'interna').toLowerCase()
          );
        } else {
          setViaticosStandardActivados(false);
          setViaticosPlameId('');
          setViaticosNumeroReciboActivo(false);
          setViaticosDestinoDefault('interna');
        }
      } catch (error) {
        console.error('Error al cargar configuración de viáticos standard:', error);
        setViaticosStandardActivados(false);
      }

      try {
        const respPlame = await plameConfiguracionService.obtenerConfiguraciones({ per_page: 1000 });
        const lista = respPlame?.success
          ? (respPlame?.data?.data || respPlame?.data || [])
          : (respPlame?.data || respPlame?.configuraciones || []);
        setConceptosPlameViaticos(Array.isArray(lista) ? lista : []);
      } catch (error) {
        console.error('Error al cargar conceptos PLAME para viáticos:', error);
        setConceptosPlameViaticos([]);
      }

      try {
        const configExpediente = await configuracionExpedienteLaboralService.obtenerConfiguracion(
          selectedCompany.id
        );
        if (configExpediente.success) {
          setExpedienteLaboralActivado(configExpediente.data?.activo ?? false);
        } else {
          setExpedienteLaboralActivado(false);
        }
      } catch (error) {
        console.error('Error al cargar configuración de expediente laboral:', error);
        setExpedienteLaboralActivado(false);
      }

    } catch (error) {
      console.error('❌ Error al cargar datos:', error);
      mostrarMensaje('error', 'Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const mostrarMensaje = (tipo, texto) => {
    setToastType(tipo);
    setToastMessage(texto);
  };

  const handleToastClose = () => {
    setToastMessage('');
  };

  const getIconoAtributo = (nombreAtributo) => {
    const iconos = {
      'Cargos': '👔',
      'Categorías': '🏷️',
      'Proyectos': '🏗️',
      'Áreas': '📍',
      'Tipos de Contratación': '📄'
    };
    return iconos[nombreAtributo] || '📝';
  };

  const guardarConfiguracionTareo = async () => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      const response = await configuracionTareoService.actualizarConfiguracionTareo(
        selectedCompany.id,
        tipoTareo,
        descontarDescansos,
        tipoTareo === 1 ? modoHorasSimple : 'reales'
      );
      
      if (response.success) {
        const tipoNombre = tiposTareoCompletos.find(t => t.id === tipoTareo)?.nombre || 'desconocido';
        mostrarMensaje('success', `Configuración de tareo ${tipoNombre} guardada exitosamente`);
      } else {
        mostrarMensaje('error', response.error || 'Error al guardar configuración de tareo');
      }
    } catch (error) {
      console.error('Error al guardar configuración de tareo:', error);
      mostrarMensaje('error', 'Error al guardar configuración de tareo');
    }
  };

  const handleToggleRentaQuinta = async (e) => {
    const nuevoEstado = e.target.checked;
    
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      console.log('💰 Cambiando configuración de renta de quinta:', nuevoEstado);
      
      // Actualizar el estado inmediatamente para mejor UX
      setRentaQuintaActivada(nuevoEstado);
      
      // Llamar al servicio real
      const response = await configuracionRentaQuintaService.actualizarConfiguracion(selectedCompany.id, nuevoEstado);
      
      if (response.success) {
        const estado = nuevoEstado ? 'activada' : 'desactivada';
        mostrarMensaje('success', `Renta de quinta ${estado} exitosamente`);
      } else {
        // Si falla, revertir el estado
        setRentaQuintaActivada(!nuevoEstado);
        mostrarMensaje('error', response.error || 'Error al actualizar configuración de renta de quinta');
      }
    } catch (error) {
      console.error('Error al actualizar configuración de renta de quinta:', error);
      // Si falla, revertir el estado
      setRentaQuintaActivada(!nuevoEstado);
      mostrarMensaje('error', 'Error al actualizar configuración de renta de quinta');
    }
  };

  const guardarConfiguracionTasaNocturna = async ({
    activo,
    horas_tasa_nocturna,
    calcular_en_planilla = calcularTasaNocturnaEnPlanilla,
  }) => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return { success: false };
    }

    const horasNumero = Number(horas_tasa_nocturna);
    if (!Number.isFinite(horasNumero) || horasNumero <= 0 || horasNumero > 24) {
      mostrarMensaje('error', 'Ingresa un número de horas válido entre 0.01 y 24');
      return { success: false };
    }

    setGuardandoTasaNocturna(true);
    try {
      const response = await configuracionTasaNocturnaService.actualizarConfiguracion(selectedCompany.id, {
        activo,
        horas_tasa_nocturna: horasNumero,
        calcular_en_planilla,
      });

      if (response.success) {
        setTasaNocturnaActivada(response.data.activo);
        setCalcularTasaNocturnaEnPlanilla(response.data.calcular_en_planilla ?? true);
        setHorasTasaNocturna(String(response.data.horas_tasa_nocturna ?? horasNumero));
        return { success: true, message: response.message };
      }

      mostrarMensaje('error', response.error || 'Error al guardar configuración de tasa nocturna');
      return { success: false };
    } catch (error) {
      console.error('Error al guardar configuración de tasa nocturna:', error);
      mostrarMensaje('error', 'Error al guardar configuración de tasa nocturna');
      return { success: false };
    } finally {
      setGuardandoTasaNocturna(false);
    }
  };

  const handleToggleTasaNocturna = async (e) => {
    const nuevoEstado = e.target.checked;
    const horasActuales = horasTasaNocturna;

    setTasaNocturnaActivada(nuevoEstado);
    const resultado = await guardarConfiguracionTasaNocturna({
      activo: nuevoEstado,
      horas_tasa_nocturna: horasActuales,
    });

    if (resultado.success) {
      const estado = nuevoEstado ? 'habilitada' : 'deshabilitada';
      mostrarMensaje('success', `Tasa nocturna ${estado} exitosamente`);
    } else {
      setTasaNocturnaActivada(!nuevoEstado);
    }
  };

  const handleGuardarHorasTasaNocturna = async () => {
    const resultado = await guardarConfiguracionTasaNocturna({
      activo: tasaNocturnaActivada,
      horas_tasa_nocturna: horasTasaNocturna,
    });
    if (resultado.success) {
      mostrarMensaje('success', 'Horas de tasa nocturna guardadas exitosamente');
    }
  };

  const handleToggleCalcularTasaNocturnaEnPlanilla = async (e) => {
    const nuevoEstado = e.target.checked;
    setCalcularTasaNocturnaEnPlanilla(nuevoEstado);
    const resultado = await guardarConfiguracionTasaNocturna({
      activo: tasaNocturnaActivada,
      horas_tasa_nocturna: horasTasaNocturna,
      calcular_en_planilla: nuevoEstado,
    });

    if (resultado.success) {
      mostrarMensaje(
        'success',
        nuevoEstado
          ? 'La tasa nocturna se calculará en planilla'
          : 'La tasa nocturna no se calculará en planilla'
      );
    } else {
      setCalcularTasaNocturnaEnPlanilla(!nuevoEstado);
    }
  };

  const handleToggleContratos = async (e) => {
    const nuevoEstado = e.target.checked;

    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      setContratosActivados(nuevoEstado);

      const response = await configuracionContratosService.actualizarConfiguracion(selectedCompany.id, nuevoEstado);

      if (response.success) {
        const estado = nuevoEstado ? 'activados' : 'desactivados';
        mostrarMensaje('success', `Contratos ${estado} exitosamente`);
        window.dispatchEvent(new Event('configuracion-contratos-actualizada'));
        if (nuevoEstado) {
          await cargarFuncionesCargoContrato();
        } else {
          setFuncionesCargoContrato([]);
          limpiarFormularioFuncionesCargo();
        }
      } else {
        setContratosActivados(!nuevoEstado);
        mostrarMensaje('error', response.error || 'Error al actualizar configuración de contratos');
      }
    } catch (error) {
      console.error('Error al actualizar configuración de contratos:', error);
      setContratosActivados(!nuevoEstado);
      mostrarMensaje('error', 'Error al actualizar configuración de contratos');
    }
  };

  const handleTogglePlanillaAlternativa = async (e) => {
    const nuevoEstado = e.target.checked;

    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      setPlanillaAlternativaActivada(nuevoEstado);
      const response = await configuracionPlanillaAlternativaService.actualizarConfiguracion(
        selectedCompany.id,
        nuevoEstado
      );

      if (response.success) {
        mostrarMensaje(
          'success',
          response.message ||
            (nuevoEstado
              ? 'Modo planilla alternativa activado'
              : 'Modo planilla alternativa desactivado')
        );
        window.dispatchEvent(new Event('configuracion-planilla-alternativa-actualizada'));
      } else {
        setPlanillaAlternativaActivada(!nuevoEstado);
        mostrarMensaje('error', response.error || 'Error al actualizar planilla alternativa');
      }
    } catch (error) {
      console.error('Error al actualizar planilla alternativa:', error);
      setPlanillaAlternativaActivada(!nuevoEstado);
      mostrarMensaje('error', 'Error al actualizar planilla alternativa');
    }
  };

  const handleCambiarEstiloBoleta = async (nuevoEstilo) => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    const anterior = estiloBoleta;
    try {
      setEstiloBoleta(nuevoEstilo);
      const response = await configuracionBoletaService.actualizarConfiguracion(
        selectedCompany.id,
        nuevoEstilo
      );

      if (response.success) {
        if (response.data?.estilo_boleta) {
          setEstiloBoleta(String(response.data.estilo_boleta).toLowerCase());
        }
        mostrarMensaje('success', response.message || 'Estilo de boleta actualizado');
        window.dispatchEvent(new Event('configuracion-boleta-actualizada'));
      } else {
        setEstiloBoleta(anterior);
        mostrarMensaje('error', response.error || 'Error al actualizar estilo de boleta');
      }
    } catch (error) {
      console.error('Error al actualizar estilo de boleta:', error);
      setEstiloBoleta(anterior);
      mostrarMensaje('error', 'Error al actualizar estilo de boleta');
    }
  };

  const handleToggleViaticosStandard = async (e) => {
    const nuevoEstado = e.target.checked;

    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      setViaticosStandardActivados(nuevoEstado);
      const response = await configuracionViaticosStandardService.actualizarConfiguracion(
        selectedCompany.id,
        {
          activo: nuevoEstado,
          plame_configuracion_id: viaticosPlameId ? Number(viaticosPlameId) : null,
          numero_recibo_activo: viaticosNumeroReciboActivo,
          tipo_boleta_destino: viaticosDestinoDefault || 'interna',
        }
      );

      if (response.success) {
        if (response.data?.plame_configuracion_id) {
          setViaticosPlameId(String(response.data.plame_configuracion_id));
        }
        if (response.data?.numero_recibo_activo != null) {
          setViaticosNumeroReciboActivo(Boolean(response.data.numero_recibo_activo));
        }
        if (response.data?.tipo_boleta_destino) {
          setViaticosDestinoDefault(String(response.data.tipo_boleta_destino).toLowerCase());
        }
        mostrarMensaje(
          'success',
          response.message ||
            (nuevoEstado
              ? 'Viáticos standard habilitados'
              : 'Viáticos standard deshabilitados')
        );
        window.dispatchEvent(new Event('configuracion-viaticos-standard-actualizada'));
      } else {
        setViaticosStandardActivados(!nuevoEstado);
        mostrarMensaje('error', response.error || 'Error al actualizar viáticos standard');
      }
    } catch (error) {
      console.error('Error al actualizar viáticos standard:', error);
      setViaticosStandardActivados(!nuevoEstado);
      mostrarMensaje('error', 'Error al actualizar viáticos standard');
    }
  };

  const handleToggleNumeroReciboViaticos = async (e) => {
    const nuevoEstado = e.target.checked;

    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      setViaticosNumeroReciboActivo(nuevoEstado);
      const response = await configuracionViaticosStandardService.actualizarConfiguracion(
        selectedCompany.id,
        {
          activo: viaticosStandardActivados,
          plame_configuracion_id: viaticosPlameId ? Number(viaticosPlameId) : null,
          numero_recibo_activo: nuevoEstado,
          tipo_boleta_destino: viaticosDestinoDefault || 'interna',
        }
      );

      if (response.success) {
        setViaticosNumeroReciboActivo(Boolean(response.data?.numero_recibo_activo ?? nuevoEstado));
        mostrarMensaje(
          'success',
          nuevoEstado
            ? 'Número de recibo habilitado'
            : 'Número de recibo deshabilitado'
        );
        window.dispatchEvent(new Event('configuracion-viaticos-standard-actualizada'));
      } else {
        setViaticosNumeroReciboActivo(!nuevoEstado);
        mostrarMensaje('error', response.error || 'Error al guardar número de recibo');
      }
    } catch (error) {
      console.error('Error al guardar número de recibo:', error);
      setViaticosNumeroReciboActivo(!nuevoEstado);
      mostrarMensaje('error', 'Error al guardar número de recibo');
    }
  };

  const guardarOpcionesViaticos = async () => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }
    try {
      setGuardandoViaticosExtra(true);
      const response = await configuracionViaticosStandardService.actualizarConfiguracion(
        selectedCompany.id,
        {
          activo: viaticosStandardActivados,
          plame_configuracion_id: viaticosPlameId ? Number(viaticosPlameId) : null,
          numero_recibo_activo: viaticosNumeroReciboActivo,
          tipo_boleta_destino: viaticosDestinoDefault || 'interna',
        }
      );
      if (response.success) {
        if (response.data?.numero_recibo_activo != null) {
          setViaticosNumeroReciboActivo(Boolean(response.data.numero_recibo_activo));
        }
        if (response.data?.tipo_boleta_destino) {
          setViaticosDestinoDefault(String(response.data.tipo_boleta_destino).toLowerCase());
        }
        mostrarMensaje('success', 'Opciones de viáticos guardadas');
        window.dispatchEvent(new Event('configuracion-viaticos-standard-actualizada'));
      } else {
        mostrarMensaje('error', response.error || 'No se pudieron guardar las opciones de viáticos');
      }
    } catch (error) {
      console.error('Error al guardar opciones de viáticos:', error);
      mostrarMensaje('error', 'Error al guardar opciones de viáticos');
    } finally {
      setGuardandoViaticosExtra(false);
    }
  };

  const handleToggleExpedienteLaboral = async (e) => {
    const nuevoEstado = e.target.checked;

    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      setExpedienteLaboralActivado(nuevoEstado);
      const response = await configuracionExpedienteLaboralService.actualizarConfiguracion(
        selectedCompany.id,
        nuevoEstado
      );

      if (response.success) {
        mostrarMensaje(
          'success',
          response.message ||
            (nuevoEstado
              ? 'Expediente laboral habilitado'
              : 'Expediente laboral deshabilitado')
        );
        window.dispatchEvent(new Event('configuracion-expediente-laboral-actualizada'));
      } else {
        setExpedienteLaboralActivado(!nuevoEstado);
        mostrarMensaje('error', response.error || 'Error al actualizar expediente laboral');
      }
    } catch (error) {
      console.error('Error al actualizar expediente laboral:', error);
      setExpedienteLaboralActivado(!nuevoEstado);
      mostrarMensaje('error', 'Error al actualizar expediente laboral');
    }
  };

  const limpiarFormularioFuncionesCargo = () => {
    setCargoFuncionesSeleccionado('');
    setTextoFuncionesCargo('');
    setEditandoFuncionesCargoId(null);
  };

  const cargarFuncionesCargoContrato = async () => {
    if (!selectedCompany?.id) return;

    setLoadingFuncionesCargo(true);
    try {
      const response = await funcionesCargoContratoService.obtenerPorEmpresa(selectedCompany.id);
      if (response.success) {
        setFuncionesCargoContrato(response.data || []);
      } else {
        setFuncionesCargoContrato([]);
      }
    } catch (error) {
      console.error('Error al cargar funciones del cargo:', error);
      setFuncionesCargoContrato([]);
    } finally {
      setLoadingFuncionesCargo(false);
    }
  };

  const editarFuncionesCargo = (registro) => {
    setEditandoFuncionesCargoId(registro.id);
    setCargoFuncionesSeleccionado(registro.cargo || '');
    setTextoFuncionesCargo(registro.funciones || '');
  };

  const guardarFuncionesCargo = async () => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }
    if (!cargoFuncionesSeleccionado) {
      mostrarMensaje('error', 'Selecciona un cargo');
      return;
    }
    if (!textoFuncionesCargo.trim()) {
      mostrarMensaje('error', 'Escribe las funciones del cargo');
      return;
    }

    setGuardandoFuncionesCargo(true);
    try {
      const response = await funcionesCargoContratoService.guardar(
        selectedCompany.id,
        cargoFuncionesSeleccionado,
        textoFuncionesCargo.trim()
      );

      if (response.success) {
        mostrarMensaje('success', response.message || 'Funciones del cargo guardadas');
        limpiarFormularioFuncionesCargo();
        await cargarFuncionesCargoContrato();
      } else {
        mostrarMensaje('error', response.error || 'No se pudieron guardar las funciones del cargo');
      }
    } catch (error) {
      console.error('Error al guardar funciones del cargo:', error);
      mostrarMensaje('error', 'No se pudieron guardar las funciones del cargo');
    } finally {
      setGuardandoFuncionesCargo(false);
    }
  };

  const eliminarFuncionesCargo = async (id) => {
    if (!window.confirm('¿Deseas eliminar las funciones configuradas para este cargo?')) return;

    try {
      const response = await funcionesCargoContratoService.eliminar(id);
      if (response.success) {
        mostrarMensaje('success', response.message || 'Funciones del cargo eliminadas');
        if (editandoFuncionesCargoId === id) {
          limpiarFormularioFuncionesCargo();
        }
        await cargarFuncionesCargoContrato();
      } else {
        mostrarMensaje('error', response.error || 'No se pudieron eliminar las funciones del cargo');
      }
    } catch (error) {
      console.error('Error al eliminar funciones del cargo:', error);
      mostrarMensaje('error', 'No se pudieron eliminar las funciones del cargo');
    }
  };

  const cargarConceptosAfectos = async () => {
    if (!selectedCompany?.id) return;

    setLoadingConceptosAfectos(true);
    try {
      const response = await conceptosAfectosTareosService.obtenerConceptosAfectos(selectedCompany.id);
      
      if (response.success) {
        setConceptosAfectos(response.data);
      } else {
        console.error('Error al cargar conceptos afectos:', response.error);
      }
    } catch (error) {
      console.error('Error al cargar conceptos afectos a tareos:', error);
    } finally {
      setLoadingConceptosAfectos(false);
    }
  };

  const cargarConceptosEstaticos = async () => {
    if (!selectedCompany?.id) return;

    setLoadingConceptosEstaticos(true);
    try {
      const response = await conceptosEstaticosService.obtenerConceptosEstaticos(selectedCompany.id);
      
      if (response.success) {
        setConceptosEstaticos(response.data);
      } else {
        console.error('Error al cargar conceptos estáticos:', response.error);
      }
    } catch (error) {
      console.error('Error al cargar conceptos estáticos:', error);
    } finally {
      setLoadingConceptosEstaticos(false);
    }
  };

  const handleConceptosModalSuccess = (mensaje) => {
    mostrarMensaje('success', mensaje);
    cargarConceptosAfectos(); // Recargar la lista
  };

  const abrirModalConceptos = () => {
    setShowConceptosModal(true);
  };

  const cerrarModalConceptos = () => {
    setShowConceptosModal(false);
  };

  const cargarConceptosNoAfectanVacaciones = async () => {
    if (!selectedCompany?.id) return;
    setLoadingConceptosNoVacaciones(true);
    try {
      const response = await conceptosNoAfectanVacacionesService.obtenerConceptos(selectedCompany.id);
      if (response.success) {
        setConceptosNoAfectanVacaciones(response.data);
      } else {
        console.error('Error al cargar conceptos no afectan vacaciones:', response.error);
      }
    } catch (e) {
      console.error('Error al cargar conceptos no afectan vacaciones:', e);
    } finally {
      setLoadingConceptosNoVacaciones(false);
    }
  };

  const handleConceptosNoVacacionesModalSuccess = (mensaje) => {
    mostrarMensaje('success', mensaje);
    cargarConceptosNoAfectanVacaciones();
  };

  const cargarConceptosAfectanLicenciaGoceHaber = async () => {
    if (!selectedCompany?.id) return;
    setLoadingConceptosLicenciaGoce(true);
    try {
      const response = await conceptosAfectanLicenciaGoceHaberService.obtenerConceptos(selectedCompany.id);
      if (response.success) {
        setConceptosAfectanLicenciaGoceHaber(response.data);
      } else {
        console.error('Error al cargar conceptos licencia goce:', response.error);
        setConceptosAfectanLicenciaGoceHaber([]);
      }
    } catch (e) {
      console.error('Error al cargar conceptos licencia goce:', e);
      setConceptosAfectanLicenciaGoceHaber([]);
    } finally {
      setLoadingConceptosLicenciaGoce(false);
    }
  };

  const handleConceptosLicenciaGoceModalSuccess = (mensaje) => {
    mostrarMensaje('success', mensaje);
    cargarConceptosAfectanLicenciaGoceHaber();
  };

  const handleConceptosEstaticosModalSuccess = (mensaje) => {
    mostrarMensaje('success', mensaje);
    cargarConceptosEstaticos(); // Recargar la lista
  };

  const abrirModalConceptosEstaticos = () => {
    setShowConceptosEstaticosModal(true);
  };

  const cerrarModalConceptosEstaticos = () => {
    setShowConceptosEstaticosModal(false);
  };

  const cargarAsignacionesUsuarioProyecto = async () => {
    if (!selectedCompany?.id) return;

    setLoadingAsignaciones(true);
    try {
      console.log('👥 Cargando asignaciones usuario-proyecto desde el backend...');
      
      const response = await asignacionUsuarioProyectoService.obtenerAsignaciones(selectedCompany.id);
      
      if (response.success) {
        setAsignacionesUsuarioProyecto(response.data);
        console.log('✅ Asignaciones usuario-proyecto cargadas exitosamente:', response.data);
      } else {
        console.error('❌ Error al cargar asignaciones:', response.error);
        mostrarMensaje('error', response.error || 'Error al cargar asignaciones usuario-proyecto');
        
        // En caso de error, usar datos vacíos en lugar de datos mock
        setAsignacionesUsuarioProyecto([]);
      }
      
    } catch (error) {
      console.error('❌ Error al cargar asignaciones usuario-proyecto:', error);
      mostrarMensaje('error', 'Error al cargar asignaciones usuario-proyecto');
      
      // En caso de error, usar datos vacíos
      setAsignacionesUsuarioProyecto([]);
    } finally {
      setLoadingAsignaciones(false);
    }
  };

  const handleAsignacionesModalSuccess = (mensaje) => {
    mostrarMensaje('success', mensaje);
    cargarAsignacionesUsuarioProyecto(); // Recargar la lista
  };

  const abrirModalAsignaciones = () => {
    setShowAsignacionesModal(true);
  };

  const cerrarModalAsignaciones = () => {
    setShowAsignacionesModal(false);
  };

  const formatearDia = (valor) => {
    const dia = Number(valor);
    if (!Number.isInteger(dia) || dia < 1 || dia > 31) return '';
    return String(dia).padStart(2, '0');
  };

  const cargarFechasComputoRh = async () => {
    if (!selectedCompany?.id) return;
    setLoadingFechasComputoRh(true);
    try {
      const response = await fechasComputoRhService.obtenerFechas(selectedCompany.id);
      if (response.success) {
        setFechasComputoRh(response.data || []);
      } else {
      console.error('Error al cargar fechas de cómputo de recibo por honorarios:', response.error);
        setFechasComputoRh([]);
      }
    } catch (error) {
      console.error('Error al cargar fechas de cómputo de recibo por honorarios:', error);
      setFechasComputoRh([]);
    } finally {
      setLoadingFechasComputoRh(false);
    }
  };

  const agregarFechaComputoRh = async () => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }
    if (!diaComputoRh) {
      mostrarMensaje('error', 'Ingrese un día de cómputo');
      return;
    }
    const dia = Number(diaComputoRh);
    if (!Number.isInteger(dia) || dia < 1 || dia > 31) {
      mostrarMensaje('error', 'El día de cómputo debe estar entre 1 y 31');
      return;
    }
    if (!tituloFechaComputoRh.trim()) {
      mostrarMensaje('error', 'Ingrese un título para la fecha de cómputo');
      return;
    }

    setGuardandoFechaComputoRh(true);
    try {
      const response = await fechasComputoRhService.agregarFecha(
        selectedCompany.id,
        tituloFechaComputoRh.trim(),
        dia
      );
      if (response.success) {
        mostrarMensaje('success', response.message || 'Fecha de cómputo de recibo por honorarios agregada');
        setTituloFechaComputoRh('');
        setDiaComputoRh('');
        await cargarFechasComputoRh();
      } else {
        mostrarMensaje('error', response.error || 'No se pudo guardar la fecha');
      }
    } catch (error) {
      console.error('Error al agregar fecha de cómputo de recibo por honorarios:', error);
      mostrarMensaje('error', 'No se pudo guardar la fecha');
    } finally {
      setGuardandoFechaComputoRh(false);
    }
  };

  const eliminarFechaComputoRh = async (id) => {
    if (!window.confirm('¿Deseas eliminar esta fecha de cómputo de recibo por honorarios?')) return;
    try {
      const response = await fechasComputoRhService.eliminarFecha(id);
      if (response.success) {
        mostrarMensaje('success', response.message || 'Fecha eliminada');
        await cargarFechasComputoRh();
      } else {
        mostrarMensaje('error', response.error || 'No se pudo eliminar la fecha');
      }
    } catch (error) {
      console.error('Error al eliminar fecha de cómputo de recibo por honorarios:', error);
      mostrarMensaje('error', 'No se pudo eliminar la fecha');
    }
  };

  const cargarConfiguracionAniversariosLaborales = async () => {
    if (!selectedCompany?.id) return;
    try {
      const response = await configuracionAniversarioLaboralService.obtenerConfiguracion(
        selectedCompany.id
      );
      if (response.success && response.data) {
        const activo = response.data.activo ?? false;
        setAniversariosActivados(activo);
        setAniosAniversario(String(response.data.anios ?? 5));
        setDiasAnticipacionAniversario(String(response.data.dias_anticipacion ?? 60));
        if (activo) {
          await consultarProximosAniversarios(
            response.data.anios ?? 5,
            response.data.dias_anticipacion ?? 60,
            { silencioso: true }
          );
        } else {
          setResultadoAniversarios(null);
        }
      } else {
        setAniversariosActivados(false);
        setAniosAniversario('5');
        setDiasAnticipacionAniversario('60');
        setResultadoAniversarios(null);
      }
    } catch (error) {
      console.error('Error al cargar configuración de aniversarios laborales:', error);
      setAniversariosActivados(false);
      setAniosAniversario('5');
      setDiasAnticipacionAniversario('60');
      setResultadoAniversarios(null);
    }
  };

  const consultarProximosAniversarios = async (
    aniosParam = null,
    diasParam = null,
    { silencioso = false } = {}
  ) => {
    if (!selectedCompany?.id) {
      if (!silencioso) mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    const anios = parseInt(aniosParam ?? aniosAniversario, 10);
    const dias = parseInt(diasParam ?? diasAnticipacionAniversario, 10);

    if (!anios || anios < 1) {
      if (!silencioso) mostrarMensaje('error', 'Ingresa un número de años válido (mínimo 1)');
      return;
    }
    if (!dias || dias < 1) {
      if (!silencioso) mostrarMensaje('error', 'Ingresa los días de anticipación (mínimo 1)');
      return;
    }

    setLoadingAniversarios(true);
    try {
      const response = await empleadoService.getProximosAniversarios({
        empresa_id: selectedCompany.id,
        anios,
        dias_anticipacion: dias,
      });

      if (response.success) {
        setResultadoAniversarios(response.data);
        if (!silencioso) {
          const total = response.data?.total ?? 0;
          mostrarMensaje(
            total > 0 ? 'success' : 'info',
            response.message || (total > 0 ? `${total} trabajador(es) encontrados` : 'Sin coincidencias')
          );
        }
      } else {
        setResultadoAniversarios(null);
        if (!silencioso) mostrarMensaje('error', response.message || 'No se pudo consultar');
      }
    } catch (error) {
      console.error('Error al consultar aniversarios laborales:', error);
      setResultadoAniversarios(null);
      if (!silencioso) {
        mostrarMensaje('error', error.message || 'No se pudo consultar los aniversarios');
      }
    } finally {
      setLoadingAniversarios(false);
    }
  };

  const guardarConfiguracionAniversariosLaborales = async (activoOverride = null) => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    const activo = activoOverride !== null ? Boolean(activoOverride) : aniversariosActivados;
    const anios = parseInt(aniosAniversario, 10);
    const dias = parseInt(diasAnticipacionAniversario, 10);

    if (!anios || anios < 1) {
      mostrarMensaje('error', 'Ingresa un número de años válido (mínimo 1)');
      return;
    }
    if (!dias || dias < 1) {
      mostrarMensaje('error', 'Ingresa los días de anticipación (mínimo 1)');
      return;
    }

    setGuardandoAniversarios(true);
    try {
      const response = await configuracionAniversarioLaboralService.actualizarConfiguracion(
        selectedCompany.id,
        { activo, anios, dias_anticipacion: dias }
      );

      if (response.success) {
        setAniversariosActivados(response.data?.activo ?? activo);
        setAniosAniversario(String(response.data?.anios ?? anios));
        setDiasAnticipacionAniversario(String(response.data?.dias_anticipacion ?? dias));
        mostrarMensaje('success', response.message || 'Configuración guardada');
        if (response.data?.activo ?? activo) {
          await consultarProximosAniversarios(
            response.data?.anios ?? anios,
            response.data?.dias_anticipacion ?? dias,
            { silencioso: true }
          );
        } else {
          setResultadoAniversarios(null);
        }
      } else {
        mostrarMensaje('error', response.error || 'No se pudo guardar la configuración');
      }
    } catch (error) {
      console.error('Error al guardar aniversarios laborales:', error);
      mostrarMensaje('error', error.message || 'No se pudo guardar la configuración');
    } finally {
      setGuardandoAniversarios(false);
    }
  };

  const handleToggleAniversariosLaborales = async (e) => {
    const nuevoEstado = e.target.checked;
    setAniversariosActivados(nuevoEstado);
    await guardarConfiguracionAniversariosLaborales(nuevoEstado);
  };

  const formatearFechaFeriado = (valor) => {
    if (!valor) return '';
    const s = String(valor).split('T')[0];
    const [y, m, d] = s.split('-');
    if (!y || !m || !d) return s;
    return `${d}/${m}/${y}`;
  };

  const cargarFeriadosPagoDoble = async () => {
    if (!selectedCompany?.id) return;
    setLoadingFeriadosPagoDoble(true);
    try {
      const response = await feriadosPagoDobleService.obtenerFeriados(selectedCompany.id);
      if (response.success) {
        setFeriadosPagoDoble(response.data || []);
      } else {
        setFeriadosPagoDoble([]);
      }
    } catch (error) {
      console.error('Error al cargar feriados con pago doble:', error);
      setFeriadosPagoDoble([]);
    } finally {
      setLoadingFeriadosPagoDoble(false);
    }
  };

  const agregarFeriadoPagoDoble = async () => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }
    if (!fechaFeriadoPagoDoble) {
      mostrarMensaje('error', 'Indica la fecha del feriado');
      return;
    }
    if (!descripcionFeriadoPagoDoble.trim()) {
      mostrarMensaje('error', 'Indica la descripción del feriado');
      return;
    }

    setGuardandoFeriadoPagoDoble(true);
    try {
      const response = await feriadosPagoDobleService.agregarFeriado(
        selectedCompany.id,
        fechaFeriadoPagoDoble,
        descripcionFeriadoPagoDoble.trim()
      );
      if (response.success) {
        mostrarMensaje('success', response.message || 'Feriado registrado');
        setFechaFeriadoPagoDoble('');
        setDescripcionFeriadoPagoDoble('');
        await cargarFeriadosPagoDoble();
      } else {
        mostrarMensaje('error', response.error || 'No se pudo guardar el feriado');
      }
    } catch (error) {
      console.error('Error al agregar feriado con pago doble:', error);
      mostrarMensaje('error', 'No se pudo guardar el feriado');
    } finally {
      setGuardandoFeriadoPagoDoble(false);
    }
  };

  const eliminarFeriadoPagoDoble = async (id) => {
    if (!window.confirm('¿Deseas eliminar este feriado con pago doble?')) return;
    try {
      const response = await feriadosPagoDobleService.eliminarFeriado(id);
      if (response.success) {
        mostrarMensaje('success', response.message || 'Feriado eliminado');
        await cargarFeriadosPagoDoble();
      } else {
        mostrarMensaje('error', response.error || 'No se pudo eliminar el feriado');
      }
    } catch (error) {
      console.error('Error al eliminar feriado con pago doble:', error);
      mostrarMensaje('error', 'No se pudo eliminar el feriado');
    }
  };

  // Funciones para manejo de firmas
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validar que sea JPG
    if (!file.type.includes('jpeg') && !file.type.includes('jpg')) {
      mostrarMensaje('error', 'Solo se permiten archivos JPG');
      return;
    }

    // Validar tamaño (max 2MB)
    if (file.size > 2 * 1024 * 1024) {
      mostrarMensaje('error', 'El archivo no puede ser mayor a 2MB');
      return;
    }

    setSelectedFirma(file);
    
    // Crear preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewFirma(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const subirFirma = async () => {
    if (!selectedFirma || !selectedCompany?.id) return;
    
    setUploadingFirma(true);
    try {
      const formData = new FormData();
      formData.append('firma', selectedFirma);
      formData.append('empresa_id', selectedCompany.id);
      
      // Obtener token desde localStorage con las diferentes posibles claves
      const token = localStorage.getItem('token') || 
                   localStorage.getItem('planillas_sanctum_token') || 
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
      
      console.log('🚀 Subiendo firma para empresa:', selectedCompany.id);
      console.log('📁 Archivo seleccionado:', selectedFirma.name, selectedFirma.size, selectedFirma.type);
      
      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/upload-firma`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        },
        body: formData
      });
      
      console.log('📡 Respuesta del servidor:', response.status, response.statusText);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('✅ Resultado:', result);
      
      if (result.success) {
        setFirmaActual(resolverUrlArchivoPublico(result.firma_url));
        setSelectedFirma(null);
        setPreviewFirma(null);
        mostrarMensaje('success', 'Firma subida exitosamente');
        // Limpiar el input file
        const inputElement = document.getElementById('firma-input');
        if (inputElement) {
          inputElement.value = '';
        }
      } else {
        mostrarMensaje('error', result.message || 'Error al subir la firma');
      }
    } catch (error) {
      console.error('❌ Error al subir firma:', error);
      mostrarMensaje('error', `Error al subir la firma: ${error.message}`);
    } finally {
      setUploadingFirma(false);
    }
  };

  const cargarFirmaActual = async () => {
    if (!selectedCompany?.id) return;
    
    setLoadingFirma(true);
    try {
      // Obtener token desde localStorage con las diferentes posibles claves
      const token = localStorage.getItem('token') || 
                   localStorage.getItem('planillas_sanctum_token') || 
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
      
      console.log('📥 Cargando firma actual para empresa:', selectedCompany.id);
      
      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-firma/${selectedCompany.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        }
      });
      
      if (!response.ok) {
        console.log('⚠️ No se pudo cargar la firma:', response.status);
        return;
      }
      
      const result = await response.json();
      console.log('📥 Resultado carga firma:', result);
      
      if (result.success && result.firma_url) {
        setFirmaActual(resolverUrlArchivoPublico(result.firma_url));
      }
    } catch (error) {
      console.error('❌ Error al cargar firma actual:', error);
    } finally {
      setLoadingFirma(false);
    }
  };

  const handleLogoFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.includes('jpeg') && !file.type.includes('jpg') && !file.type.includes('png')) {
      mostrarMensaje('error', 'Solo se permiten archivos JPG o PNG');
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      mostrarMensaje('error', 'El archivo no puede ser mayor a 2MB');
      return;
    }

    setSelectedLogo(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewLogo(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const subirLogo = async () => {
    if (!selectedLogo || !selectedCompany?.id) return;

    setUploadingLogo(true);
    try {
      const formData = new FormData();
      formData.append('logo', selectedLogo);
      formData.append('empresa_id', selectedCompany.id);

      const token = localStorage.getItem('token') ||
                   localStorage.getItem('planillas_sanctum_token') ||
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);

      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/upload-logo`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setLogoActual(resolverUrlArchivoPublico(result.logo_url));
        setSelectedLogo(null);
        setPreviewLogo(null);
        mostrarMensaje('success', 'Logo subido exitosamente');
        const inputElement = document.getElementById('logo-input');
        if (inputElement) {
          inputElement.value = '';
        }
      } else {
        mostrarMensaje('error', result.message || 'Error al subir el logo');
      }
    } catch (error) {
      console.error('Error al subir logo:', error);
      mostrarMensaje('error', `Error al subir el logo: ${error.message}`);
    } finally {
      setUploadingLogo(false);
    }
  };

  const cargarLogoActual = async () => {
    if (!selectedCompany?.id) return;

    setLoadingLogo(true);
    try {
      const token = localStorage.getItem('token') ||
                   localStorage.getItem('planillas_sanctum_token') ||
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);

      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-logo/${selectedCompany.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      if (!response.ok) return;

      const result = await response.json();

      if (result.success && result.logo_url) {
        setLogoActual(resolverUrlArchivoPublico(result.logo_url));
      } else {
        setLogoActual(null);
      }
    } catch (error) {
      console.error('Error al cargar logo actual:', error);
    } finally {
      setLoadingLogo(false);
    }
  };

  const eliminarLogo = async () => {
    if (!selectedCompany?.id || !logoActual) return;

    if (!window.confirm('¿Estás seguro de que deseas eliminar el logo actual?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token') ||
                   localStorage.getItem('planillas_sanctum_token') ||
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);

      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/delete-logo/${selectedCompany.id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setLogoActual(null);
        mostrarMensaje('success', 'Logo eliminado exitosamente');
      } else {
        mostrarMensaje('error', result.message || 'Error al eliminar el logo');
      }
    } catch (error) {
      console.error('Error al eliminar logo:', error);
      mostrarMensaje('error', `Error al eliminar el logo: ${error.message}`);
    }
  };

  const cargarRepresentanteLegal = async () => {
    if (!selectedCompany?.id) return;

    setRepresentanteLegal(selectedCompany.representante_legal ?? '');
    setDireccionEmpresa(selectedCompany.direccion ?? '');
    setDniRepresentante(selectedCompany.dni_representante ?? '');

    try {
      const response = await empresaService.obtenerEmpresa(selectedCompany.id);
      if (response.status === 'success' && response.data) {
        setRepresentanteLegal(response.data.representante_legal ?? '');
        setDireccionEmpresa(response.data.direccion ?? '');
        setDniRepresentante(response.data.dni_representante ?? '');
      }
    } catch (error) {
      console.error('Error al cargar representante legal:', error);
    }
  };

  const guardarRepresentanteLegal = async () => {
    if (!selectedCompany?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    setGuardandoRepresentanteLegal(true);
    try {
      const response = await empresaService.actualizarRepresentanteLegal(
        selectedCompany.id,
        {
          representante_legal: representanteLegal.trim(),
          direccion: direccionEmpresa.trim(),
          dni_representante: dniRepresentante.trim(),
        }
      );

      if (response.status === 'success') {
        const data = response.data ?? {};
        setRepresentanteLegal(data.representante_legal ?? '');
        setDireccionEmpresa(data.direccion ?? '');
        setDniRepresentante(data.dni_representante ?? '');
        selectCompany({
          ...selectedCompany,
          representante_legal: data.representante_legal || null,
          direccion: data.direccion || null,
          dni_representante: data.dni_representante || null,
        });
        mostrarMensaje('success', 'Datos del representante guardados correctamente');
      } else {
        mostrarMensaje('error', response.message || 'No se pudieron guardar los datos');
      }
    } catch (error) {
      console.error('Error al guardar representante legal:', error);
      mostrarMensaje('error', 'No se pudieron guardar los datos');
    } finally {
      setGuardandoRepresentanteLegal(false);
    }
  };

  const eliminarFirma = async () => {
    if (!selectedCompany?.id || !firmaActual) return;
    
    if (!window.confirm('¿Estás seguro de que deseas eliminar la firma actual?')) {
      return;
    }
    
    try {
      // Obtener token desde localStorage con las diferentes posibles claves
      const token = localStorage.getItem('token') || 
                   localStorage.getItem('planillas_sanctum_token') || 
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
      
      console.log('🗑️ Eliminando firma para empresa:', selectedCompany.id);
      
      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/delete-firma/${selectedCompany.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('🗑️ Resultado eliminación:', result);
      
      if (result.success) {
        setFirmaActual(null);
        mostrarMensaje('success', 'Firma eliminada exitosamente');
      } else {
        mostrarMensaje('error', result.message || 'Error al eliminar la firma');
      }
    } catch (error) {
      console.error('❌ Error al eliminar firma:', error);
      mostrarMensaje('error', `Error al eliminar la firma: ${error.message}`);
    }
  };



  const agregarAtributo = async (atributoId, valor) => {
    if (!valor.trim() || !selectedCompany?.id) return;
    
    try {
      const response = await atributoService.crearSubAtributo(atributoId, selectedCompany.id, valor);
      
      if (response.success) {
        // Recargar los datos para obtener la lista actualizada
        await cargarAtributos();
        mostrarMensaje('success', response.message || 'Elemento agregado exitosamente');
      } else {
        mostrarMensaje('error', response.error || 'Error al agregar elemento');
      }
    } catch (error) {
      console.error('Error al agregar atributo:', error);
      mostrarMensaje('error', 'Error al agregar elemento');
    }
  };

  const eliminarAtributo = async (subAtributoId) => {
    if (!selectedCompany?.id) return;
    
    try {
      const response = await atributoService.eliminarSubAtributo(subAtributoId);
      
      if (response.success) {
        // Recargar los datos para obtener la lista actualizada
        await cargarAtributos();
        mostrarMensaje('success', response.message || 'Elemento eliminado exitosamente');
      } else {
        mostrarMensaje('error', response.error || 'Error al eliminar elemento');
      }
    } catch (error) {
      console.error('Error al eliminar atributo:', error);
      mostrarMensaje('error', 'Error al eliminar elemento');
    }
  };

  // Función auxiliar para recargar solo los atributos
  const cargarAtributos = async () => {
    if (!selectedCompany?.id) return;
    
    try {
      const configuracionResponse = await atributoService.obtenerConfiguracionCompleta(selectedCompany.id);
      
      if (configuracionResponse.success) {
        setAtributosData(configuracionResponse.data.sub_atributos || {});
      }
    } catch (error) {
      console.error('Error al cargar atributos:', error);
    }
  };

  // Estados para nuevos items en atributos (usando un objeto para manejar múltiples tipos)
  const [nuevosItems, setNuevosItems] = useState({});

  const getNuevoItemState = (atributoId) => {
    const valor = nuevosItems[atributoId] || '';
    const setter = (nuevoValor) => {
      setNuevosItems(prev => ({
        ...prev,
        [atributoId]: nuevoValor
      }));
    };
    return [valor, setter];
  };

  const renderAtributosList = (atributo, items, icono) => {
    const [nuevoItem, setNuevoItem] = getNuevoItemState(atributo.id);

    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 h-full flex flex-col">
        <div className="flex flex-col space-y-3 mb-4">
          <h4 className="text-lg font-semibold text-gray-900 flex items-center">
            <span className="text-xl mr-2">{icono}</span>
            <span className="truncate">{atributo.nombre}</span>
          </h4>
          <div className="flex flex-col sm:flex-row gap-2">
            <input
              type="text"
              value={nuevoItem}
              onChange={(e) => setNuevoItem(e.target.value)}
              placeholder={`Nuevo ${atributo.nombre.toLowerCase().slice(0, -1)}`}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && nuevoItem.trim()) {
                  agregarAtributo(atributo.id, nuevoItem);
                  setNuevoItem('');
                }
              }}
            />
            <button
              onClick={() => {
                if (nuevoItem.trim()) {
                  agregarAtributo(atributo.id, nuevoItem);
                  setNuevoItem('');
                }
              }}
              disabled={!nuevoItem.trim()}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm disabled:bg-gray-300 disabled:cursor-not-allowed whitespace-nowrap"
            >
              Agregar
            </button>
          </div>
        </div>
        
        <div className="flex-1 overflow-hidden">
          <div className="space-y-2 max-h-48 overflow-y-auto pr-2">
            {(!items || items.length === 0) ? (
              <div className="text-center py-8 text-gray-500">
                <p className="text-sm">No hay elementos agregados</p>
              </div>
            ) : (
              items.map((item, index) => (
                <div key={item.id || index} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-md group hover:bg-gray-100 transition-colors">
                  <span className="text-sm text-gray-700 flex-1 truncate pr-2" title={item.nombre}>
                    {item.nombre}
                  </span>
                  <button
                    onClick={() => eliminarAtributo(item.id)}
                    className="text-red-500 hover:text-red-700 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0"
                    title="Eliminar"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="ml-2 text-gray-600">Cargando configuración...</span>
        </div>
      </div>
    );
  }

  if (!selectedCompany) {
    return (
      <div className="p-6">
        <div className="flex flex-col items-center justify-center h-64">
          <div className="text-gray-400 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No hay empresa seleccionada</h3>
          <p className="text-gray-500 text-center">
            Selecciona una empresa para ver y gestionar la configuración del sistema.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Configuración del Sistema</h1>
        <p className="text-gray-600">Administra los parámetros generales del sistema de planillas</p>
      </div>



      {/* Sección UIT y RMV */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* UIT */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 bg-orange-50 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center">
              <span className="text-2xl mr-3">📊</span>
              UIT - Unidad Impositiva Tributaria
            </h3>
            <p className="text-sm text-gray-600 mt-1">Valor actual para cálculos tributarios</p>
          </div>
          <div className="p-6">
            {uitData.length > 0 && uitData[0] ? (
              <div className="space-y-4">
                <div className="text-center">
                  <div className="text-4xl font-bold text-orange-600">
                    S/ {parseFloat(uitData[0].monto || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <div className="text-gray-400 mb-2">
                  <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-gray-500">No hay datos de UIT disponibles</p>
              </div>
            )}
          </div>
        </div>

        {/* RMV */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 bg-teal-50 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center">
              <span className="text-2xl mr-3">💰</span>
              RMV - Remuneración Mínima Vital
            </h3>
            <p className="text-sm text-gray-600 mt-1">Sueldo mínimo mensual vigente</p>
          </div>
          <div className="p-6">
            {sueldoMinimoData.length > 0 && sueldoMinimoData[0] ? (
              <div className="space-y-4">
                <div className="text-center">
                  <div className="text-4xl font-bold text-teal-600">
                    S/ {parseFloat(sueldoMinimoData[0].monto || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <div className="text-gray-400 mb-2">
                  <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                  </svg>
                </div>
                <p className="text-gray-500">No hay datos de sueldo mínimo disponibles</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Sección Atributos */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">⚙️</span>
          Atributos del Sistema
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {tiposAtributos
            .filter(atributo => atributo.nombre !== 'Motivos de Cese')
            .map((atributo) => {
              const items = atributosData[atributo.nombre] || [];
              const icono = getIconoAtributo(atributo.nombre);
              return (
                <div key={atributo.id}>
                  {renderAtributosList(atributo, items, icono)}
                </div>
              );
            })}
        </div>
      </div>

      {/* Configuración de Tareo */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">⏰</span>
          Configuración de Tareo
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-600">Selecciona el tipo de tareo que se utilizará en el sistema:</p>
          
          <div className="space-y-3">
            {tiposTareoCompletos.map((tipo) => (
              <label key={tipo.id} className="flex items-center space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors">
                <input
                  type="radio"
                  name="tipoTareo"
                  value={tipo.id}
                  checked={tipoTareo === tipo.id}
                  onChange={(e) => setTipoTareo(parseInt(e.target.value))}
                  className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                />
                <div className="flex-1">
                  <div className="font-medium text-gray-900">{tipo.nombre}</div>
                  <div className="text-sm text-gray-500 mt-1">
                    {tipo.descripcion}
                  </div>
                </div>
              </label>
            ))}
          </div>

          {/* Toggle para Descontar Descansos */}
          <div className="border-t border-gray-200 pt-6 mt-6">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h4 className="text-lg font-medium text-gray-900 flex items-center">
                  <span className="text-xl mr-2">🏖️</span>
                  Descontar Descansos
                </h4>
                <p className="text-sm text-gray-600 mt-1">
                  Define si los días de descanso se descuentan en los cálculos de planilla
                </p>
              </div>
              <div className="flex items-center ml-6">
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={descontarDescansos}
                    onChange={(e) => setDescontarDescansos(e.target.checked)}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  <span className="ml-3 text-sm font-medium text-gray-700">
                    {descontarDescansos ? 'Activado' : 'Desactivado'}
                  </span>
                </label>
              </div>
            </div>
          </div>

          {/* Solo tareo simple: cómo contar horas en planilla */}
          {tipoTareo === 1 && (
            <div className="border-t border-gray-200 pt-6 mt-6">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">⏱️</span>
                Conteo de horas en planilla (tareo simple)
              </h4>
              <p className="text-sm text-gray-600 mb-4">
                Los tareos guardan las horas reales en base de datos. Si eliges 8 horas fijas,
                en el modal de tareos y en la planilla el conteo se muestra como 8h por día
                asistido / feriado laborado / descanso laborado.
              </p>
              <div className="space-y-3">
                <label className="flex items-start space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                  <input
                    type="radio"
                    name="modoHorasSimple"
                    value="reales"
                    checked={modoHorasSimple === 'reales'}
                    onChange={() => setModoHorasSimple('reales')}
                    className="mt-1 w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <div>
                    <div className="font-medium text-gray-900">Horas reales</div>
                    <div className="text-sm text-gray-500">
                      La planilla suma las horas que vienen de cada tareo (p. ej. 9h si trabajó 09:00–19:00).
                    </div>
                  </div>
                </label>
                <label className="flex items-start space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                  <input
                    type="radio"
                    name="modoHorasSimple"
                    value="fijas_8"
                    checked={modoHorasSimple === 'fijas_8'}
                    onChange={() => setModoHorasSimple('fijas_8')}
                    className="mt-1 w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <div>
                    <div className="font-medium text-gray-900">Igualar a 8 horas</div>
                    <div className="text-sm text-gray-500">
                      En tareos (vista) y planilla, cada día asistido / feriado laborado / descanso laborado
                      cuenta como 8h (en BD se conservan las horas reales).
                    </div>
                  </div>
                </label>
              </div>
            </div>
          )}
          
          <div className="pt-4">
            <button
              onClick={guardarConfiguracionTareo}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Guardar Configuración de Tareo
            </button>
          </div>
        </div>
      </div>

      {/* Configuración de Renta de Quinta */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">💰</span>
          Configuración de Renta de Quinta
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-600">
            Configura si el sistema debe calcular automáticamente la renta de quinta categoría para los empleados.
          </p>
          
          {/* Mensaje de advertencia sobre cálculo proyectado */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center">
                  <span className="text-yellow-600 text-sm">⚠️</span>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-yellow-800 mb-1">Importante: Cálculo Proyectado Anual</h4>
                <p className="text-sm text-yellow-700">
                  El sistema calculará la renta de quinta categoría proyectando los ingresos del empleado a un año completo, 
                  independientemente del período trabajado.
                </p>
              </div>
            </div>
          </div>
          
          {/* Toggle principal con guardado automático */}
          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">📊</span>
                Cálculo Automático de Renta de Quinta
              </h4>
              <p className="text-sm text-gray-600">
                {rentaQuintaActivada 
                  ? 'El sistema calculará automáticamente la renta de quinta para empleados que superen las 7 UIT anuales.'
                  : 'El cálculo de renta de quinta está desactivado. Los empleados no tendrán este descuento automático.'
                }
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={rentaQuintaActivada}
                  onChange={handleToggleRentaQuinta}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {rentaQuintaActivada ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Configuración de Tasa Nocturna */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🌙</span>
          Tasa Nocturna
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Habilita la tasa nocturna en tareos y define cuántas horas se consideran por jornada nocturna.
            Puedes activar el marcado en tareos sin incluir el cálculo automático en planilla.
          </p>

          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">🕒</span>
                Habilitar tasa nocturna
              </h4>
              <p className="text-sm text-gray-600">
                {tasaNocturnaActivada
                  ? 'La tasa nocturna está activa para esta empresa.'
                  : 'La tasa nocturna está desactivada. Actívala cuando debas aplicar el cálculo nocturno.'}
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={tasaNocturnaActivada}
                  onChange={handleToggleTasaNocturna}
                  disabled={guardandoTasaNocturna}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {tasaNocturnaActivada ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>

          {tasaNocturnaActivada && (
            <>
            <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
              <div className="flex-1">
                <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                  <span className="text-xl mr-2">📋</span>
                  Calcular en planilla
                </h4>
                <p className="text-sm text-gray-600">
                  {calcularTasaNocturnaEnPlanilla
                    ? 'Al procesar la planilla se agregará el ingreso PLAME 0309 según los tareos marcados.'
                    : 'Los tareos pueden seguir marcando tasa nocturna, pero la planilla no calculará el concepto 0309.'}
                </p>
              </div>
              <div className="flex items-center ml-6">
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={calcularTasaNocturnaEnPlanilla}
                    onChange={handleToggleCalcularTasaNocturnaEnPlanilla}
                    disabled={guardandoTasaNocturna}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                  <span className="ml-3 text-sm font-medium text-gray-700">
                    {calcularTasaNocturnaEnPlanilla ? 'Activado' : 'Desactivado'}
                  </span>
                </label>
              </div>
            </div>

            <div className="p-6 bg-indigo-50/40 rounded-lg border border-indigo-200">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Número de horas de tasa nocturna
              </label>
              <div className="flex flex-col sm:flex-row sm:items-end gap-3">
                <div className="sm:w-48">
                  <input
                    type="number"
                    min="0.01"
                    max="24"
                    step="0.01"
                    value={horasTasaNocturna}
                    onChange={(e) => setHorasTasaNocturna(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Ej: 8"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleGuardarHorasTasaNocturna}
                  disabled={guardandoTasaNocturna}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
                >
                  {guardandoTasaNocturna ? 'Guardando...' : 'Guardar horas'}
                </button>
              </div>
              <p className="mt-2 text-xs text-gray-500">
                Cantidad de horas que el sistema tomará como jornada nocturna (máximo 24).
              </p>
            </div>
            </>
          )}
        </div>
      </div>

      {/* Modo planilla alternativa */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🔀</span>
          Planilla alternativa
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Activa el modo dual cuando la empresa maneja planilla <strong>real (PLAME)</strong> y una
            planilla <strong>interna de control</strong>. Al activarlo, en empleados podrás elegir Dual
            o Solo interna, registrar fechas/sueldos separados y acoplar al personal ya existente.
          </p>

          <div className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950">
            <p className="font-semibold mb-1">Advertencia</p>
            <p>
              El sistema no se hace responsable del uso que los usuarios den a las herramientas
              disponibles. La activación y el manejo de esta función quedan bajo exclusiva
              responsabilidad de la empresa y de quien opera el sistema.
            </p>
          </div>

          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">⚙️</span>
                Activar modo planilla alternativa
              </h4>
              <p className="text-sm text-gray-600">
                {planillaAlternativaActivada
                  ? 'Modo activo: real = PLAME, interna = control. Usa “Acoplar personal” en Empleados para migrar al personal ya cargado.'
                  : 'El modo está desactivado. Actívalo solo si la empresa opera con doble planilla.'}
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={planillaAlternativaActivada}
                  onChange={handleTogglePlanillaAlternativa}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {planillaAlternativaActivada ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Estilo de boleta */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🧾</span>
          Estilo de boleta
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Elige el diseño de las boletas PDF. Todos comparten la misma información;
            solo cambia la paleta. El logo de la empresa aparece arriba a la izquierda.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              {
                id: 'colorido',
                titulo: 'A color',
                desc: 'Diseño vivo con verdes, rojos y azules por sección.',
                preview: (
                  <div className="flex gap-1 h-3 rounded overflow-hidden">
                    <span className="flex-1 bg-emerald-700" />
                    <span className="flex-1 bg-red-600" />
                    <span className="flex-1 bg-blue-800" />
                  </div>
                ),
              },
              {
                id: 'estandar',
                titulo: 'Estándar (casi incolora)',
                desc: 'Grises sobrios; solo franjas laterales de color en las tarjetas.',
                preview: (
                  <div className="flex gap-1 h-3 rounded overflow-hidden border border-gray-200">
                    <span className="flex-1 bg-gray-200" />
                    <span className="flex-1 bg-gray-100" />
                    <span className="flex-1 bg-gray-300" />
                  </div>
                ),
              },
              {
                id: 'azul_oro',
                titulo: 'Azul oro',
                desc: 'Misma estructura que la estándar, con navy y cian.',
                preview: (
                  <div className="flex gap-1 h-3 rounded overflow-hidden">
                    <span className="flex-1" style={{ background: '#001A72' }} />
                    <span className="flex-1" style={{ background: '#3EB5E5' }} />
                    <span className="flex-1" style={{ background: '#001A72' }} />
                  </div>
                ),
              },
            ].map((op) => {
              const activo = estiloBoleta === op.id;
              return (
                <button
                  key={op.id}
                  type="button"
                  onClick={() => handleCambiarEstiloBoleta(op.id)}
                  className={`text-left p-4 rounded-lg border transition-all ${
                    activo
                      ? 'border-indigo-500 ring-2 ring-indigo-200 bg-indigo-50'
                      : 'border-gray-200 bg-gray-50 hover:border-gray-300'
                  }`}
                >
                  <div className="mb-3">{op.preview}</div>
                  <h4 className="text-base font-semibold text-gray-900 mb-1 flex items-center gap-2">
                    {op.titulo}
                    {activo && (
                      <span className="text-xs font-medium text-indigo-700 bg-indigo-100 px-2 py-0.5 rounded">
                        Activo
                      </span>
                    )}
                  </h4>
                  <p className="text-sm text-gray-600">{op.desc}</p>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Viáticos standard */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🧳</span>
          Viáticos standard
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Al habilitarlo, en empleados aparece el <strong>monto de viático esperado</strong> y en la
            importación de tareo calendario (modo simple) se habilita la columna de{' '}
            <strong>monto viático</strong>. Opcionalmente puedes activar también el{' '}
            <strong>N° de recibo</strong>. Los viáticos se <strong>informan</strong> en planilla/REM
            (igual que las gratificaciones) pero <strong>no afectan el neto a pagar</strong>.
          </p>

          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">✈️</span>
                Habilitar viáticos standard
              </h4>
              <p className="text-sm text-gray-600">
                {viaticosStandardActivados
                  ? 'Activo: empleados, plantilla calendario e importación usan esta sección.'
                  : 'Desactivado: no se muestra viático en empleados ni en el calendario de tareos.'}
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={viaticosStandardActivados}
                  onChange={handleToggleViaticosStandard}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {viaticosStandardActivados ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>

          {viaticosStandardActivados && (
            <div className="p-4 border border-amber-200 bg-amber-50/60 rounded-lg space-y-4">
              <div className="flex items-center justify-between p-4 bg-white rounded-lg border border-amber-100">
                <div className="flex-1 pr-4">
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">Habilitar número de recibo</h4>
                  <p className="text-xs text-gray-600">
                    Si está activo, la plantilla calendario e importación incluyen la columna{' '}
                    <strong>N° recibo</strong> por trabajador.
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer shrink-0">
                  <input
                    type="checkbox"
                    checked={viaticosNumeroReciboActivo}
                    onChange={handleToggleNumeroReciboViaticos}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-amber-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-600"></div>
                  <span className="ml-3 text-sm font-medium text-gray-700">
                    {viaticosNumeroReciboActivo ? 'Activado' : 'Desactivado'}
                  </span>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-800 mb-1">
                  Código PLAME de viáticos
                </label>
                <p className="text-xs text-gray-600 mb-2">
                  Concepto con el que se cargará el monto de viático al importar el calendario.
                  El destino (PLAME / interna / ambas) se indica por trabajador en la importación de tareos.
                </p>
                <select
                  value={viaticosPlameId}
                  onChange={(e) => setViaticosPlameId(e.target.value)}
                  className="w-full max-w-xl rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-teal-500 focus:ring-teal-500"
                >
                  <option value="">Seleccione un código…</option>
                  {conceptosPlameViaticos.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.codigo_plame} — {c.descripcion || c.nombre || 'Concepto'}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-800 mb-1">
                  Destino por defecto (si Destino queda vacío en el Excel)
                </label>
                <p className="text-xs text-gray-600 mb-2">
                  Solo aplica con planilla alternativa. Si en la celda Destino escribe{' '}
                  <strong>ambas</strong>, el viático irá a PLAME e Interna.
                </p>
                <select
                  value={viaticosDestinoDefault}
                  onChange={(e) => setViaticosDestinoDefault(e.target.value)}
                  className="w-full max-w-xl rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-teal-500 focus:ring-teal-500"
                >
                  <option value="interna">Interna</option>
                  <option value="plame">PLAME</option>
                  <option value="ambas">Ambas</option>
                </select>
              </div>

              <button
                type="button"
                onClick={guardarOpcionesViaticos}
                disabled={guardandoViaticosExtra}
                className="px-4 py-2 bg-teal-600 text-white text-sm font-medium rounded-md hover:bg-teal-700 disabled:bg-gray-400"
              >
                {guardandoViaticosExtra ? 'Guardando…' : 'Guardar opciones de viáticos'}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Expediente laboral */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🗂️</span>
          Expediente laboral
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Al habilitarlo, en el formulario de empleados aparece una pestaña para subir{' '}
            <strong>DNI</strong>, <strong>CV</strong> (con indicador documentado),{' '}
            <strong>antecedentes policiales</strong> (con alerta de vencimiento a 3 meses),{' '}
            <strong>alta PLAME</strong> y <strong>derechohabientes</strong>.
          </p>

          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">📁</span>
                Habilitar expediente laboral
              </h4>
              <p className="text-sm text-gray-600">
                {expedienteLaboralActivado
                  ? 'Activo: en empleados aparece la pestaña Expediente laboral.'
                  : 'Desactivado: no se muestra la pestaña de expediente en empleados.'}
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={expedienteLaboralActivado}
                  onChange={handleToggleExpedienteLaboral}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {expedienteLaboralActivado ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Activar Contratos */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">📄</span>
          Contratos
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Habilita la gestión de contratos en el sistema para esta empresa.
          </p>

          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                <span className="text-xl mr-2">📋</span>
                Activar contratos
              </h4>
              <p className="text-sm text-gray-600">
                {contratosActivados
                  ? 'La funcionalidad de contratos está habilitada para esta empresa.'
                  : 'La funcionalidad de contratos está desactivada. Actívala cuando necesites gestionar contratos de empleados.'
                }
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={contratosActivados}
                  onChange={handleToggleContratos}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {contratosActivados ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>

          {contratosActivados && (
            <div className="mt-6 border border-indigo-200 rounded-lg bg-indigo-50/40 p-5 space-y-4">
              <div>
                <h4 className="text-lg font-medium text-gray-900 flex items-center mb-2">
                  <span className="text-xl mr-2">👔</span>
                  Funciones del cargo
                </h4>
                <p className="text-sm text-gray-600">
                  Define el detalle de funciones por cargo para usarlo en las plantillas de contrato con la variable
                  <code className="mx-1 px-1.5 py-0.5 bg-white border border-gray-200 rounded text-xs">{'{{empleado.funciones_cargo}}'}</code>.
                  Puedes redactar textos largos; en el contrato se respetarán los saltos de línea.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-4 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Cargo</label>
                  <select
                    value={cargoFuncionesSeleccionado}
                    onChange={(e) => setCargoFuncionesSeleccionado(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <option value="">Seleccionar cargo...</option>
                    {(atributosData.Cargos || []).map((cargo) => (
                      <option key={cargo.id} value={cargo.nombre}>
                        {cargo.nombre}
                      </option>
                    ))}
                  </select>
                  {(atributosData.Cargos || []).length === 0 && (
                    <p className="mt-2 text-xs text-amber-700">
                      Primero registra cargos en la sección de atributos de esta configuración.
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Funciones del cargo</label>
                  <textarea
                    value={textoFuncionesCargo}
                    onChange={(e) => setTextoFuncionesCargo(e.target.value)}
                    rows={12}
                    maxLength={20000}
                    placeholder={'Ejemplo:\na) Ejecutar las labores asignadas...\nb) Cumplir con las normas de seguridad...\nc) Reportar incidentes...'}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-mono text-sm leading-relaxed resize-y min-h-[220px]"
                  />
                  <p className="mt-1 text-xs text-gray-500 text-right">
                    {textoFuncionesCargo.length.toLocaleString('es-PE')} / 20.000 caracteres
                  </p>
                </div>

                <div className="flex flex-wrap gap-3">
                  <button
                    type="button"
                    onClick={guardarFuncionesCargo}
                    disabled={guardandoFuncionesCargo || !cargoFuncionesSeleccionado || !textoFuncionesCargo.trim()}
                    className="px-5 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                  >
                    {guardandoFuncionesCargo
                      ? 'Guardando...'
                      : editandoFuncionesCargoId
                        ? 'Actualizar funciones'
                        : 'Guardar funciones'}
                  </button>
                  {editandoFuncionesCargoId && (
                    <button
                      type="button"
                      onClick={limpiarFormularioFuncionesCargo}
                      className="px-5 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      Cancelar edición
                    </button>
                  )}
                </div>
              </div>

              <div className="border border-gray-200 rounded-lg bg-white">
                <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                  <h5 className="text-sm font-medium text-gray-700">Cargos configurados</h5>
                  <span className="text-xs text-gray-500">
                    {loadingFuncionesCargo ? 'Cargando...' : `${funcionesCargoContrato.length} cargo(s)`}
                  </span>
                </div>

                {loadingFuncionesCargo ? (
                  <p className="p-4 text-sm text-gray-500">Cargando funciones del cargo...</p>
                ) : funcionesCargoContrato.length === 0 ? (
                  <p className="p-4 text-sm text-gray-500">
                    Aún no hay funciones registradas. Selecciona un cargo y guarda el texto para usarlo en los contratos.
                  </p>
                ) : (
                  <div className="divide-y divide-gray-200">
                    {funcionesCargoContrato.map((item) => (
                      <div key={item.id} className="p-4 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                        <div className="min-w-0 flex-1">
                          <p className="text-sm font-semibold text-gray-900">{item.cargo}</p>
                          <p className="mt-2 text-sm text-gray-600 whitespace-pre-line line-clamp-4">
                            {item.funciones}
                          </p>
                        </div>
                        <div className="flex gap-2 shrink-0">
                          <button
                            type="button"
                            onClick={() => editarFuncionesCargo(item)}
                            className="px-3 py-1.5 text-sm border border-indigo-200 text-indigo-700 rounded-lg hover:bg-indigo-50"
                          >
                            Editar
                          </button>
                          <button
                            type="button"
                            onClick={() => eliminarFuncionesCargo(item.id)}
                            className="px-3 py-1.5 text-sm border border-red-200 text-red-700 rounded-lg hover:bg-red-50"
                          >
                            Eliminar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Feriados laborados con pago doble */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🎉</span>
          Feriados laborados con pago doble
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Registra fechas específicas en las que un feriado laborado se paga al doble (2 jornales en lugar de 1).
            Solo aplican los días que marques aquí; el resto de feriados laborados siguen el pago normal.
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-800">
              Ejemplo: si registras el 28 de julio como &quot;Fiestas Patrias&quot;, cada tareo de tipo
              <strong> feriado laborado </strong> en esa fecha sumará el equivalente a 2 días en el concepto PLAME 0107.
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex flex-col sm:flex-row gap-3 sm:items-end">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fecha del feriado
                </label>
                <input
                  type="date"
                  value={fechaFeriadoPagoDoble}
                  onChange={(e) => setFechaFeriadoPagoDoble(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
              </div>
              <div className="flex-[2]">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Descripción
                </label>
                <input
                  type="text"
                  value={descripcionFeriadoPagoDoble}
                  onChange={(e) => setDescripcionFeriadoPagoDoble(e.target.value)}
                  placeholder="Ej: Fiestas Patrias"
                  maxLength={255}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                />
              </div>
              <button
                type="button"
                onClick={agregarFeriadoPagoDoble}
                disabled={!fechaFeriadoPagoDoble || !descripcionFeriadoPagoDoble.trim() || guardandoFeriadoPagoDoble}
                className="px-6 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                {guardandoFeriadoPagoDoble ? 'Guardando...' : 'Agregar feriado'}
              </button>
            </div>
          </div>

          <div className="border border-gray-200 rounded-lg">
            <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
              <h4 className="text-sm font-medium text-gray-700">Feriados registrados</h4>
              <span className="text-xs text-gray-500">
                {loadingFeriadosPagoDoble ? 'Cargando...' : `${feriadosPagoDoble.length} feriado(s)`}
              </span>
            </div>

            <div className="p-4">
              {loadingFeriadosPagoDoble ? (
                <div className="text-sm text-gray-500">Cargando feriados...</div>
              ) : feriadosPagoDoble.length === 0 ? (
                <div className="text-sm text-gray-500">No hay feriados con pago doble registrados.</div>
              ) : (
                <div className="space-y-2">
                  {feriadosPagoDoble.map((item) => (
                    <div key={item.id} className="flex items-center justify-between p-3 bg-amber-50 border border-amber-200 rounded-lg">
                      <div>
                        <p className="text-sm font-semibold text-gray-900">{item.descripcion || 'Sin descripción'}</p>
                        <p className="text-xs text-gray-600">
                          {formatearFechaFeriado(item.fecha)} — pago doble en feriado laborado
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={() => eliminarFeriadoPagoDoble(item.id)}
                        className="text-red-600 hover:text-red-800 text-sm font-medium"
                      >
                        Eliminar
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Fechas de Cómputo - Recibo por Honorarios */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">📅</span>
          Fechas de Cómputo - Recibo por Honorarios
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Configura el día fijo de cómputo que se replica cada mes. Ejemplo: día 15 implica
            período de planilla del 15 al 14 del mes siguiente (la fecha fin es siempre el día anterior al corte).
          </p>

          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex flex-col sm:flex-row gap-3 sm:items-end">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Título
                </label>
                <input
                  type="text"
                  value={tituloFechaComputoRh}
                  onChange={(e) => setTituloFechaComputoRh(e.target.value)}
                  placeholder="Ej: Cómputo Febrero 2026"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Día de cómputo (1-31)
                </label>
                <input
                  type="number"
                  min="1"
                  max="31"
                  value={diaComputoRh}
                  onChange={(e) => setDiaComputoRh(e.target.value)}
                  placeholder="15"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <p className="text-xs text-gray-600 mt-1">
                  En planillas: desde el día {formatearDia(diaComputoRh) || '--'} hasta el día anterior al {formatearDia(diaComputoRh) || '--'} del mes siguiente (ej.: 15–14).
                </p>
              </div>
              <button
                type="button"
                onClick={agregarFechaComputoRh}
                disabled={!tituloFechaComputoRh.trim() || !diaComputoRh || guardandoFechaComputoRh}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                {guardandoFechaComputoRh ? 'Guardando...' : 'Agregar fecha'}
              </button>
            </div>
          </div>

          <div className="border border-gray-200 rounded-lg">
            <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
              <h4 className="text-sm font-medium text-gray-700">Fechas registradas</h4>
              <span className="text-xs text-gray-500">
                {loadingFechasComputoRh ? 'Cargando...' : `${fechasComputoRh.length} fecha(s)`}
              </span>
            </div>

            <div className="p-4">
              {loadingFechasComputoRh ? (
                <div className="text-sm text-gray-500">Cargando fechas...</div>
              ) : fechasComputoRh.length === 0 ? (
                <div className="text-sm text-gray-500">No hay fechas de cómputo de recibo por honorarios registradas.</div>
              ) : (
                <div className="space-y-2">
                  {fechasComputoRh.map((item) => (
                    <div key={item.id} className="flex items-center justify-between p-3 bg-blue-50 border border-blue-200 rounded-lg">
                      <div>
                        <p className="text-sm font-semibold text-gray-900">{item.titulo || 'Sin título'}</p>
                        <p className="text-xs text-gray-600">
                          Corte día {formatearDia(item.dia_inicio_computo)} — período hasta el día anterior al {formatearDia(item.dia_fin_computo)} del mes siguiente
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={() => eliminarFechaComputoRh(item.id)}
                        className="text-red-600 hover:text-red-800 text-sm font-medium"
                      >
                        Eliminar
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Aniversarios laborales / años de servicio */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">⏳</span>
          Aniversarios laborales
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Activa esta opción solo si quieres vigilar antigüedad. La lista de trabajadores próximos
            a cumplir los años configurados se muestra también en el <strong>Panel principal</strong>.
          </p>

          <div className="flex items-center justify-between p-6 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex-1">
              <h4 className="text-lg font-medium text-gray-900 mb-2">
                Activar alertas de aniversarios
              </h4>
              <p className="text-sm text-gray-600">
                {aniversariosActivados
                  ? 'Las alertas están activas y se muestran en el panel principal.'
                  : 'Las alertas están desactivadas. Actívalas cuando necesites vigilar años de servicio.'}
              </p>
            </div>
            <div className="flex items-center ml-6">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={aniversariosActivados}
                  onChange={handleToggleAniversariosLaborales}
                  disabled={guardandoAniversarios}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {aniversariosActivados ? 'Activado' : 'Desactivado'}
                </span>
              </label>
            </div>
          </div>

          {aniversariosActivados && (
            <>
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="flex flex-col sm:flex-row gap-3 sm:items-end">
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Años de servicio a cumplir
                    </label>
                    <input
                      type="number"
                      min="1"
                      max="80"
                      value={aniosAniversario}
                      onChange={(e) => setAniosAniversario(e.target.value)}
                      placeholder="Ej: 5"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Días de anticipación
                    </label>
                    <input
                      type="number"
                      min="1"
                      max="365"
                      value={diasAnticipacionAniversario}
                      onChange={(e) => setDiasAnticipacionAniversario(e.target.value)}
                      placeholder="60"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <p className="text-xs text-gray-600 mt-1">
                      Mostrar quienes cumplen en los próximos N días (incluye hoy).
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => guardarConfiguracionAniversariosLaborales()}
                      disabled={guardandoAniversarios || loadingAniversarios || !selectedCompany?.id}
                      className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                    >
                      {guardandoAniversarios ? 'Guardando...' : 'Guardar'}
                    </button>
                    <button
                      type="button"
                      onClick={() => consultarProximosAniversarios()}
                      disabled={loadingAniversarios || guardandoAniversarios || !selectedCompany?.id}
                      className="px-6 py-2 bg-white text-blue-700 border border-blue-300 rounded-lg hover:bg-blue-50 transition-colors disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
                    >
                      {loadingAniversarios ? 'Consultando...' : 'Actualizar lista'}
                    </button>
                  </div>
                </div>
              </div>

              <div className="border border-gray-200 rounded-lg">
                <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                  <h4 className="text-sm font-medium text-gray-700">
                    Trabajadores próximos a cumplir
                    {resultadoAniversarios?.anios != null ? ` ${resultadoAniversarios.anios} año(s)` : ''}
                  </h4>
                  <span className="text-xs text-gray-500">
                    {loadingAniversarios
                      ? 'Cargando...'
                      : resultadoAniversarios
                        ? `${resultadoAniversarios.total || 0} trabajador(es)`
                        : 'Sin consulta'}
                  </span>
                </div>

                <div className="p-4 overflow-x-auto">
                  {loadingAniversarios ? (
                    <div className="text-sm text-gray-500">Consultando trabajadores activos...</div>
                  ) : !resultadoAniversarios ? (
                    <div className="text-sm text-gray-500">
                      Guarda la configuración o pulsa Actualizar lista para ver quiénes van a alcanzar esa antigüedad.
                    </div>
                  ) : (resultadoAniversarios.empleados || []).length === 0 ? (
                    <div className="text-sm text-gray-500">
                      No hay trabajadores activos que cumplan {resultadoAniversarios.anios} año(s)
                      en los próximos {resultadoAniversarios.dias_anticipacion} día(s).
                    </div>
                  ) : (
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="text-left text-gray-600 border-b border-gray-200">
                          <th className="py-2 pr-3 font-medium">Trabajador</th>
                          <th className="py-2 pr-3 font-medium">Documento</th>
                          <th className="py-2 pr-3 font-medium">Cargo</th>
                          <th className="py-2 pr-3 font-medium">Ingreso</th>
                          <th className="py-2 pr-3 font-medium">Cumple el</th>
                          <th className="py-2 pr-3 font-medium">Días</th>
                          <th className="py-2 font-medium">Antigüedad actual</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(resultadoAniversarios.empleados || []).map((emp) => (
                          <tr key={emp.id} className="border-b border-gray-100 last:border-0">
                            <td className="py-2.5 pr-3 font-medium text-gray-900">{emp.nombre_completo}</td>
                            <td className="py-2.5 pr-3 text-gray-700">
                              {emp.tipo_documento} {emp.numero_documento}
                            </td>
                            <td className="py-2.5 pr-3 text-gray-700">{emp.cargo || '—'}</td>
                            <td className="py-2.5 pr-3 text-gray-700">
                              {formatearFechaAniversario(emp.fecha_ingreso)}
                            </td>
                            <td className="py-2.5 pr-3 text-gray-700">
                              {formatearFechaAniversario(emp.fecha_aniversario)}
                            </td>
                            <td className="py-2.5 pr-3">
                              <span
                                className={
                                  emp.dias_restantes <= 7
                                    ? 'inline-flex px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800'
                                    : 'inline-flex px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800'
                                }
                              >
                                {emp.dias_restantes === 0 ? 'Hoy' : `${emp.dias_restantes} d`}
                              </span>
                            </td>
                            <td className="py-2.5 text-gray-700">
                              {emp.antiguedad_actual_anios != null
                                ? `${emp.antiguedad_actual_anios} años`
                                : '—'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Conceptos Afectos a Tareos */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">💰</span>
          Conceptos Afectos a Tareos
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-600">
            Configura qué conceptos PLAME de ingresos se verán afectados por los tareos en el sistema de planillas.
          </p>
          
          {/* Estadísticas de conceptos configurados */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-sm font-medium text-gray-700">Conceptos Configurados</h3>
                <p className="text-2xl font-bold text-teal-600 mt-1">
                  {loadingConceptosAfectos ? (
                    <div className="animate-pulse bg-gray-200 h-8 w-8 rounded"></div>
                  ) : (
                    conceptosAfectos.length
                  )}
                </p>
              </div>
              <div className="text-right">
                <p className="text-xs text-gray-500">Solo conceptos de ingresos</p>
                <p className="text-xs text-gray-500">pueden ser afectos a tareos</p>
              </div>
            </div>
          </div>

          {/* Lista de conceptos configurados */}
          {conceptosAfectos.length > 0 && (
            <div className="border border-gray-200 rounded-lg">
              <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                <h4 className="text-sm font-medium text-gray-700">Conceptos Actualmente Configurados</h4>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {conceptosAfectos.map((concepto, index) => (
                    <div key={index} className="flex items-center space-x-3 p-3 bg-teal-50 border border-teal-200 rounded-lg">
                      <div className="flex-shrink-0">
                        <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {concepto.nombre || concepto.descripcion || `Concepto ${concepto.id_concepto_plame}`}
                        </p>
                        <p className="text-xs text-gray-500">
                          Código: {concepto.codigo || concepto.id_concepto_plame}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Botón para configurar conceptos */}
          <div className="pt-4">
            <button
              onClick={abrirModalConceptos}
              className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span>Configurar Conceptos Afectos</span>
            </button>
          </div>
        </div>
      </div>

      {/* Conceptos que afectan licencia con goce de haber */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🧾</span>
          Conceptos que afectan licencia con goce de haber
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Indica qué conceptos PLAME de ingresos deben descontar en el proporcional los días marcados como
            licencia con goce de haber en tareos (misma lista de códigos de ingresos que en conceptos afectos a tareos).
          </p>

          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-sm font-medium text-gray-700">Conceptos configurados</h3>
                <p className="text-2xl font-bold text-teal-600 mt-1">
                  {loadingConceptosLicenciaGoce ? (
                    <span className="inline-block animate-pulse bg-gray-200 h-8 w-8 rounded" />
                  ) : (
                    conceptosAfectanLicenciaGoceHaber.length
                  )}
                </p>
              </div>
              <div className="text-right">
                <p className="text-xs text-gray-500">Solo conceptos de ingresos</p>
                <p className="text-xs text-gray-500">pueden seleccionarse</p>
              </div>
            </div>
          </div>

          {conceptosAfectanLicenciaGoceHaber.length > 0 && (
            <div className="border border-gray-200 rounded-lg">
              <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                <h4 className="text-sm font-medium text-gray-700">Conceptos actualmente configurados</h4>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {conceptosAfectanLicenciaGoceHaber.map((concepto, index) => (
                    <div
                      key={index}
                      className="flex items-center space-x-3 p-3 bg-teal-50 border border-teal-200 rounded-lg"
                    >
                      <div className="w-2 h-2 bg-teal-500 rounded-full flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {concepto.nombre || concepto.descripcion || `Concepto ${concepto.id_concepto_plame}`}
                        </p>
                        <p className="text-xs text-gray-500">
                          Código: {concepto.codigo || concepto.id_concepto_plame}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="pt-4">
            <button
              type="button"
              onClick={() => setShowConceptosLicenciaGoceModal(true)}
              className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors inline-flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Configurar conceptos
            </button>
          </div>
        </div>
      </div>

      {/* Conceptos que no afectan a vacaciones */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🏖️</span>
          Conceptos que no afectan a vacaciones
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Define qué conceptos PLAME de ingresos no deben considerarse al calcular o impactar vacaciones
            (por ejemplo bonos u otros conceptos variables).
          </p>

          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-sm font-medium text-gray-700">Conceptos excluidos</h3>
                <p className="text-2xl font-bold text-indigo-600 mt-1">
                  {loadingConceptosNoVacaciones ? (
                    <span className="inline-block animate-pulse bg-gray-200 h-8 w-8 rounded" />
                  ) : (
                    conceptosNoAfectanVacaciones.length
                  )}
                </p>
              </div>
              <div className="text-right">
                <p className="text-xs text-gray-500">Misma lista de ingresos PLAME</p>
                <p className="text-xs text-gray-500">que en conceptos afectos a tareos</p>
              </div>
            </div>
          </div>

          {conceptosNoAfectanVacaciones.length > 0 && (
            <div className="border border-gray-200 rounded-lg">
              <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                <h4 className="text-sm font-medium text-gray-700">Configurados actualmente</h4>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {conceptosNoAfectanVacaciones.map((concepto, index) => (
                    <div
                      key={index}
                      className="flex items-center space-x-3 p-3 bg-indigo-50 border border-indigo-200 rounded-lg"
                    >
                      <div className="w-2 h-2 bg-indigo-500 rounded-full flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {concepto.nombre || concepto.descripcion || `Concepto ${concepto.id_concepto_plame}`}
                        </p>
                        <p className="text-xs text-gray-500">
                          Código: {concepto.codigo || concepto.id_concepto_plame}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="pt-4">
            <button
              type="button"
              onClick={() => setShowConceptosNoVacacionesModal(true)}
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors inline-flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Configurar conceptos
            </button>
          </div>
        </div>
      </div>

      {/* Conceptos Estáticos */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">📊</span>
          Conceptos Estáticos
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-600">
            Configura qué conceptos PLAME de ingresos se mantendrán como estáticos en el sistema de planillas.
          </p>
          
          {/* Estadísticas de conceptos configurados */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-sm font-medium text-gray-700">Conceptos Estáticos Configurados</h3>
                <p className="text-2xl font-bold text-purple-600 mt-1">
                  {loadingConceptosEstaticos ? (
                    <div className="animate-pulse bg-gray-200 h-8 w-8 rounded"></div>
                  ) : (
                    conceptosEstaticos.length
                  )}
                </p>
              </div>
              <div className="text-right">
                <p className="text-xs text-gray-500">Solo conceptos de ingresos</p>
                <p className="text-xs text-gray-500">pueden ser estáticos</p>
              </div>
            </div>
          </div>

          {/* Lista de conceptos configurados */}
          {conceptosEstaticos.length > 0 && (
            <div className="border border-gray-200 rounded-lg">
              <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                <h4 className="text-sm font-medium text-gray-700">Conceptos Estáticos Actualmente Configurados</h4>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {conceptosEstaticos.map((concepto, index) => (
                    <div key={index} className="flex items-center space-x-3 p-3 bg-purple-50 border border-purple-200 rounded-lg">
                      <div className="flex-shrink-0">
                        <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {concepto.nombre || concepto.descripcion || `Concepto ${concepto.id_concepto_plame}`}
                        </p>
                        <p className="text-xs text-gray-500">
                          Código: {concepto.codigo || concepto.id_concepto_plame}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Botón para configurar conceptos */}
          <div className="pt-4">
            <button
              onClick={abrirModalConceptosEstaticos}
              className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span>Configurar Conceptos Estáticos</span>
            </button>
          </div>
        </div>
      </div>

      {/* Asignación de Usuario a Proyecto */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">👥</span>
          Asignación de Usuario a Proyecto
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-600">
            Visualiza y gestiona las asignaciones de usuarios a los diferentes proyectos de la empresa.
          </p>
          


          {/* Lista de usuarios y sus asignaciones */}
          {asignacionesUsuarioProyecto.length > 0 && (
            <div className="border border-gray-200 rounded-lg">
              <div className="px-4 py-3 border-b border-gray-200 bg-gray-50">
                <h4 className="text-sm font-medium text-gray-700">Usuarios y Proyectos Asignados</h4>
              </div>
              <div className="p-4">
                <div className="space-y-4">
                  {asignacionesUsuarioProyecto.map((asignacion) => (
                    <div key={asignacion.id} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center space-x-3 mb-2">
                            <div className="flex-shrink-0">
                              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                <span className="text-blue-600 font-medium text-sm">
                                  {asignacion.usuario.nombre.split(' ').map(n => n[0]).join('').toUpperCase()}
                                </span>
                              </div>
                            </div>
                            <div className="flex-1">
                              <h5 className="text-lg font-medium text-gray-900">{asignacion.usuario.nombre}</h5>
                              <p className="text-sm text-gray-500">{asignacion.usuario.cargo}</p>
                              <p className="text-xs text-gray-400">{asignacion.usuario.email}</p>
                            </div>
                          </div>
                          
                          <div className="ml-13">
                            <h6 className="text-sm font-medium text-gray-700 mb-2 flex items-center">
                              <span className="mr-2">🏗️</span>
                              Proyectos Asignados ({asignacion.proyectos.length})
                            </h6>
                            {asignacion.proyectos.length > 0 ? (
                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                                {asignacion.proyectos.map((proyecto) => (
                                  <div key={proyecto.id} className="flex items-center space-x-2 p-2 bg-blue-50 border border-blue-200 rounded-md">
                                    <div className="flex-shrink-0">
                                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <p className="text-sm font-medium text-gray-900 truncate">
                                        {proyecto.nombre}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        {proyecto.codigo}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center py-4 text-gray-400">
                                <svg className="w-8 h-8 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                </svg>
                                <p className="text-sm">Sin proyectos asignados</p>
                              </div>
                            )}
                          </div>
                        </div>
                        
                        <div className="flex-shrink-0 ml-4">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            asignacion.proyectos.length > 0 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-orange-100 text-orange-800'
                          }`}>
                            {asignacion.proyectos.length > 0 ? 'Asignado' : 'Sin asignar'}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Botón para gestionar asignaciones */}
          <div className="pt-4">
            <button
              onClick={abrirModalAsignaciones}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span>Gestionar Asignaciones</span>
            </button>
          </div>
        </div>
      </div>

      {/* Representante legal */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">👤</span>
          Representante legal
        </h2>

        <div className="space-y-4">
          <p className="text-gray-600">
            Datos del representante legal y de la empresa para constancias CTS, contratos y otros documentos oficiales.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
            <div>
              <label htmlFor="representante-legal" className="block text-sm font-medium text-gray-700 mb-2">
                Nombre completo
              </label>
              <input
                id="representante-legal"
                type="text"
                maxLength={250}
                value={representanteLegal}
                onChange={(e) => setRepresentanteLegal(e.target.value)}
                placeholder="Ej: Juan Pérez García"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="mt-1 text-xs text-gray-500">{representanteLegal.length}/250 caracteres</p>
            </div>

            <div>
              <label htmlFor="dni-representante" className="block text-sm font-medium text-gray-700 mb-2">
                DNI del representante
              </label>
              <input
                id="dni-representante"
                type="text"
                maxLength={20}
                value={dniRepresentante}
                onChange={(e) => setDniRepresentante(e.target.value.replace(/\D/g, '').slice(0, 20))}
                placeholder="Ej: 12345678"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="direccion-empresa" className="block text-sm font-medium text-gray-700 mb-2">
                Dirección de la empresa
              </label>
              <input
                id="direccion-empresa"
                type="text"
                maxLength={500}
                value={direccionEmpresa}
                onChange={(e) => setDireccionEmpresa(e.target.value)}
                placeholder="Ej: Av. Principal 123, Lima"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="mt-1 text-xs text-gray-500">{direccionEmpresa.length}/500 caracteres</p>
            </div>
          </div>

          <div>
            <button
              type="button"
              onClick={guardarRepresentanteLegal}
              disabled={guardandoRepresentanteLegal}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
            >
              {guardandoRepresentanteLegal ? 'Guardando...' : 'Guardar datos del representante'}
            </button>
          </div>
        </div>
      </div>

      {/* Sección de Firma de la Empresa */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">✍️</span>
          Firma de la Empresa
        </h2>
        
        <div className="space-y-6">
          <p className="text-gray-600">
            Sube la firma digital que se utilizará en los documentos oficiales de la empresa.
          </p>
          
          {/* Estado de firma actual */}
          {loadingFirma ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="ml-2 text-gray-600">Cargando firma...</span>
            </div>
          ) : firmaActual ? (
            <div className="border border-green-200 bg-green-50 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium text-green-900">Firma Empresa</h4>
                    <p className="text-sm text-green-700">Firma registrada correctamente</p>
                  </div>
                </div>
                <button
                  onClick={eliminarFirma}
                  className="px-3 py-2 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors text-sm font-medium"
                >
                  Eliminar
                </button>
              </div>
            </div>
          ) : (
            <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              <p className="mt-2 text-sm text-gray-600">No hay firma registrada</p>
            </div>
          )}

          {/* Subir nueva firma */}
          <div className="border border-gray-200 rounded-lg p-6">
            <h4 className="text-lg font-medium text-gray-900 mb-4">
              {firmaActual ? 'Reemplazar Firma' : 'Subir Firma'}
            </h4>
            
            <div className="space-y-4">
              {/* Input de archivo */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Seleccionar archivo JPG (máx. 2MB)
                </label>
                <input
                  id="firma-input"
                  type="file"
                  accept=".jpg,.jpeg"
                  onChange={handleFileSelect}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
              </div>

              {/* Preview de la imagen seleccionada */}
              {previewFirma && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Vista previa:
                  </label>
                  <div className="bg-gray-50 rounded-lg p-4 inline-block">
                    <img 
                      src={previewFirma} 
                      alt="Vista previa de la firma" 
                      className="max-h-32 max-w-full object-contain"
                      style={{ maxHeight: '128px' }}
                    />
                  </div>
                </div>
              )}

              {/* Botones de acción */}
              <div className="flex flex-col sm:flex-row gap-3 pt-4">
                <button
                  onClick={subirFirma}
                  disabled={!selectedFirma || uploadingFirma}
                  className="flex-1 sm:flex-initial px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                >
                  {uploadingFirma ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>Subiendo...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <span>{firmaActual ? 'Reemplazar' : 'Subir'} Firma</span>
                    </>
                  )}
                </button>
                
                {selectedFirma && (
                  <button
                    onClick={() => {
                      setSelectedFirma(null);
                      setPreviewFirma(null);
                      document.getElementById('firma-input').value = '';
                    }}
                    className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Información adicional y requisitos */}
          <div className="space-y-4">
            {/* Requisitos técnicos */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-blue-800 mb-2">📋 Instrucciones para subir la firma</h4>
                  
                  <div className="space-y-3">
                    <div>
                      <h5 className="text-sm font-semibold text-blue-800 mb-1">🎯 Requisitos de la imagen:</h5>
                      <ul className="text-sm text-blue-700 space-y-1 ml-3">
                        <li>• <strong>Tamaño recomendado:</strong> Entre 300-400 píxeles de ancho</li>
                        <li>• <strong>Alto:</strong> Entre 250-350 píxeles</li>
                        <li>• <strong>Proporción:</strong> Casi cuadrada (no muy alargada)</li>
                        <li>• <strong>Formato:</strong> JPG únicamente</li>
                        <li>• <strong>Tamaño archivo:</strong> Máximo 2MB</li>
                        <li>• <strong>Calidad:</strong> Alta resolución para que se vea nítida</li>
                      </ul>
                    </div>
                    
                    <div>
                      <h5 className="text-sm font-semibold text-blue-800 mb-1">✅ Cómo debe verse tu firma:</h5>
                      <ul className="text-sm text-blue-700 space-y-1 ml-3">
                        <li>• <strong>Fondo:</strong> Preferiblemente blanco o transparente</li>
                        <li>• <strong>Texto:</strong> Negro o azul oscuro para buena legibilidad</li>
                        <li>• <strong>Elementos:</strong> Firma manuscrita + datos de la empresa bien distribuidos</li>
                        <li>• <strong>Márgenes:</strong> Deja un pequeño espacio alrededor de los bordes</li>
                      </ul>
                    </div>
                    
                    <div>
                      <h5 className="text-sm font-semibold text-blue-800 mb-1">❌ Evita:</h5>
                      <ul className="text-sm text-blue-700 space-y-1 ml-3">
                        <li>• Imágenes muy anchas y poco altas (se verán desproporcionadas)</li>
                        <li>• Fondos de colores fuertes que compitan con el texto</li>
                        <li>• Resolución muy baja (se verá pixelada)</li>
                        <li>• Demasiado texto pequeño (no se leerá bien)</li>
                      </ul>
                    </div>
                    
                    <div className="bg-blue-100 rounded-md p-3 mt-3">
                      <p className="text-sm text-blue-800">
                        <strong>💡 Consejo:</strong> La imagen que subas se ajustará automáticamente al espacio designado en la boleta, manteniendo sus proporciones originales.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección de Logo de la Empresa */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
          <span className="text-2xl mr-3">🏢</span>
          Logo de la Empresa
        </h2>

        <div className="space-y-6">
          <p className="text-gray-600">
            Sube el logo que aparecerá como marca de agua centrada en toda la hoja de los contratos.
          </p>

          {loadingLogo ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="ml-2 text-gray-600">Cargando logo...</span>
            </div>
          ) : logoActual ? (
            <div className="border border-green-200 bg-green-50 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <img
                    src={logoActual}
                    alt="Logo actual de la empresa"
                    className="max-h-16 max-w-[140px] object-contain bg-white rounded border border-green-100 p-1"
                  />
                  <div>
                    <h4 className="text-lg font-medium text-green-900">Logo registrado</h4>
                    <p className="text-sm text-green-700">Se mostrará en los contratos</p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={eliminarLogo}
                  className="px-3 py-2 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors text-sm font-medium"
                >
                  Eliminar
                </button>
              </div>
            </div>
          ) : (
            <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <p className="mt-2 text-sm text-gray-600">No hay logo registrado</p>
            </div>
          )}

          <div className="border border-gray-200 rounded-lg p-6">
            <h4 className="text-lg font-medium text-gray-900 mb-4">
              {logoActual ? 'Reemplazar Logo' : 'Subir Logo'}
            </h4>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Seleccionar archivo JPG o PNG (máx. 2MB)
                </label>
                <input
                  id="logo-input"
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleLogoFileSelect}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
              </div>

              {previewLogo && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Vista previa:
                  </label>
                  <div className="bg-gray-50 rounded-lg p-4 inline-block">
                    <img
                      src={previewLogo}
                      alt="Vista previa del logo"
                      className="max-h-32 max-w-full object-contain"
                      style={{ maxHeight: '128px' }}
                    />
                  </div>
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-3 pt-4">
                <button
                  type="button"
                  onClick={subirLogo}
                  disabled={!selectedLogo || uploadingLogo}
                  className="flex-1 sm:flex-initial px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                >
                  {uploadingLogo ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>Subiendo...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <span>{logoActual ? 'Reemplazar' : 'Subir'} Logo</span>
                    </>
                  )}
                </button>

                {selectedLogo && (
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedLogo(null);
                      setPreviewLogo(null);
                      document.getElementById('logo-input').value = '';
                    }}
                    className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              <strong>Recomendación:</strong> Usa un logo con fondo transparente o blanco. Se mostrará semitransparente centrado en cada hoja, detrás del texto.
            </p>
          </div>
        </div>
      </div>

      {/* Modal de Conceptos Afectos a Tareos */}
      <ConceptosAfectosTareosModal
        isOpen={showConceptosModal}
        onClose={cerrarModalConceptos}
        empresaId={selectedCompany?.id}
        onSuccess={handleConceptosModalSuccess}
      />

      <ConceptosNoAfectanVacacionesModal
        isOpen={showConceptosNoVacacionesModal}
        onClose={() => setShowConceptosNoVacacionesModal(false)}
        empresaId={selectedCompany?.id}
        onSuccess={handleConceptosNoVacacionesModalSuccess}
      />

      <ConceptosAfectanLicenciaGoceHaberModal
        isOpen={showConceptosLicenciaGoceModal}
        onClose={() => setShowConceptosLicenciaGoceModal(false)}
        empresaId={selectedCompany?.id}
        onSuccess={handleConceptosLicenciaGoceModalSuccess}
      />

      {/* Modal de Conceptos Estáticos */}
      <ConceptosEstaticosModal
        isOpen={showConceptosEstaticosModal}
        onClose={cerrarModalConceptosEstaticos}
        empresaId={selectedCompany?.id}
        onSuccess={handleConceptosEstaticosModalSuccess}
      />

      {/* Modal de Asignaciones Usuario-Proyecto */}
      <AsignacionUsuarioProyectoModal
        isOpen={showAsignacionesModal}
        onClose={cerrarModalAsignaciones}
        empresaId={selectedCompany?.id}
        onSuccess={handleAsignacionesModalSuccess}
      />

      {/* Toast Notifications */}
      <Toast
        message={toastMessage}
        type={toastType}
        onClose={handleToastClose}
        position="top-right"
        duration={5000}
      />

    </div>
  );
};

export default Configuracion; 